import React from "react";
import NotebookWorkspace from "./childNotesPanel/NotebookWorkspace";
import ArchivumWorkspace from "./childNotesPanel/ArchivumWorkspace";
import TabulaWorkspace from "./childNotesPanel/TabulaWorkspace";
import fixWebmDuration from "fix-webm-duration";
import {
    getSharedWorkspace,
    saveSharedWorkspace,
} from "../lib/api";
import {
    ChevronLeft,
    ChevronRight,
    Download,
    FolderOpen,
    Link2,
    Maximize2,
    Minimize2,
    Monitor,
    NotebookPen,
    Pencil,
    PencilRuler,
    Pause,
    Play,
    Square,
    Trash2,
} from "lucide-react";

const editorGoldButtonClass =
    "recording-editor-action recording-editor-action-gold";

const editorPurpleButtonClass =
    "recording-editor-action recording-editor-action-purple";

const ChildNotesPanel = ({
    childId,
    scope = "dashboard",
    title = "My Notes",
    onOpenChange,
    role = "child",
}) => {
    const [isOpen, setIsOpen] =
        React.useState(true);

    const [notes, setNotes] =
        React.useState("");

    const [
        notebookPages,
        setNotebookPages,
    ] = React.useState([]);

    const [
        activeNotebookPageId,
        setActiveNotebookPageId,
    ] = React.useState(null);

    const [
        activeWorkspace,
        setActiveWorkspace,
    ] = React.useState("notepad");

    const [
        workspaceMode,
        setWorkspaceMode,
    ] = React.useState("private");
const [
    sharedWorkspace,
    setSharedWorkspace,
] = React.useState(null);

const [
    sharedStatus,
    setSharedStatus,
] = React.useState("idle");

const [
    sharedError,
    setSharedError,
] = React.useState("");

const sharedBusyRef = React.useRef(false);
const sharedEpochRef = React.useRef(0);
const sharedSnapshotRef = React.useRef("");
const sharedSaveQueueRef = React.useRef(Promise.resolve());
const saveLiveWorkspace = params => {
    const request = sharedSaveQueueRef.current.catch(() => {}).then(() => saveSharedWorkspace(params));
    sharedSaveQueueRef.current = request;
    return request;
};

const sharedSaveTimerRef =
    React.useRef(null);

const [
    recordingMode,
    setRecordingMode,
] = React.useState(null);

const [
    isRecording,
    setIsRecording,
] = React.useState(false);

const [
    pendingVideoDraftDelete,
    setPendingVideoDraftDelete,
] = React.useState(null);

const [
    isRecordingPaused,
    setIsRecordingPaused,
] = React.useState(false);

const [
    recordingSeconds,
    setRecordingSeconds,
] = React.useState(0);

const [
    recordingUrl,
    setRecordingUrl,
] = React.useState("");

const [
    recordingMimeType,
    setRecordingMimeType,
] = React.useState("");

const [
    isRecordingReviewOpen,
    setIsRecordingReviewOpen,
] = React.useState(false);

const [
    isRecordingEditorOpen,
    setIsRecordingEditorOpen,
] = React.useState(false);

const [
    isRenderingEditedRecording,
    setIsRenderingEditedRecording,
] = React.useState(false);

const [
    isSavingVideoDraft,
    setIsSavingVideoDraft,
] = React.useState(false);

const [
    activeVideoDraftId,
    setActiveVideoDraftId,
] = React.useState(null);

const [
    videoDraftSaveMessage,
    setVideoDraftSaveMessage,
] = React.useState("");

const [
    videoDrafts,
    setVideoDrafts,
] = React.useState([]);

const [
    isVideoDraftsOpen,
    setIsVideoDraftsOpen,
] = React.useState(false);

const [
    isLoadingVideoDrafts,
    setIsLoadingVideoDrafts,
] = React.useState(false);

const [
    editorMuteOriginalAudio,
    setEditorMuteOriginalAudio,
] = React.useState(false);

const [
    editorTrimStart,
    setEditorTrimStart,
] = React.useState(0);

const [
    editorTrimEnd,
    setEditorTrimEnd,
] = React.useState(0);

const [
    editorDuration,
    setEditorDuration,
] = React.useState(0);

const [
    recordingTitle,
    setRecordingTitle,
] = React.useState("");

const [
    recordingDescription,
    setRecordingDescription,
] = React.useState("");

const [
    editorPlayhead,
    setEditorPlayhead,
] = React.useState(0);

const [
    editorSegments,
    setEditorSegments,
] = React.useState([]);

const [
    editorThumbnails,
    setEditorThumbnails,
] = React.useState([]);

const [
    isGeneratingEditorThumbnails,
    setIsGeneratingEditorThumbnails,
] = React.useState(false);

const [
    isEditorPreviewing,
    setIsEditorPreviewing,
] = React.useState(false);

const [
    isSelectedRangePreviewing,
    setIsSelectedRangePreviewing,
] = React.useState(false);

const selectedRangePreviewEndRef =
    React.useRef(null);

const editorThumbnailGenerationRef =
    React.useRef(0);

const [
    recordingError,
    setRecordingError,
] = React.useState("");

const recordingEditorVideoRef =
    React.useRef(null);

const mediaRecorderRef =
    React.useRef(null);

const recordingStreamRef =
    React.useRef(null);

const microphoneStreamRef =
    React.useRef(null);

const recordingAudioContextRef =
    React.useRef(null);

const recordedChunksRef =
    React.useRef([]);

const recordingTimerRef =
    React.useRef(null);

const recordingElapsedMsRef =
    React.useRef(0);

const workspacePanelRef =
    React.useRef(null);

const recordingWasExpandedRef =
    React.useRef(false);

const [isExpanded, setIsExpanded] =
    React.useState(false);

const [
    areTopControlsHidden,
    setAreTopControlsHidden,
] = React.useState(false);

const [
    customPanelHeight,
    setCustomPanelHeight,
] = React.useState(null);

React.useEffect(() => {
    const pageBody =
        document.body;

    const pageRoot =
        document.documentElement;

    if (isExpanded) {
        pageBody.style.overflow =
            "hidden";

        pageRoot.style.overflow =
            "hidden";
    } else {
        pageBody.style.removeProperty(
            "overflow"
        );

        pageRoot.style.removeProperty(
            "overflow"
        );
    }

    return () => {
        pageBody.style.removeProperty(
            "overflow"
        );

        pageRoot.style.removeProperty(
            "overflow"
        );
    };
}, [isExpanded]);
    const [folders, setFolders] =
React.useState([]);

    const [activeFolderId, setActiveFolderId] =
        React.useState(null);

    const [newFolderName, setNewFolderName] =
        React.useState("");

    const [
        newFolderDescription,
        setNewFolderDescription,
            ] = React.useState("");

    const [
        isResourceFolderCreatorOpen,
        setIsResourceFolderCreatorOpen,
    ] = React.useState(false);

    const [editingFolderId, setEditingFolderId] =
        React.useState(null);

    const [
        editingFolderName,
        setEditingFolderName,
        ] = React.useState("");

    const [
        editingFolderDescription,
        setEditingFolderDescription,
    ] = React.useState("");

    const setPanelOpen = (nextValue) => {
        setIsOpen(nextValue);
        onOpenChange?.(nextValue);
    };

    const storageKey =
        `liberiCuriosiNotes_${childId}_${scope}_${
            activeFolderId || "general"
        }`;

    const notebookPagesStorageKey =
        `liberiCuriosiNotebookPages_${childId}_${scope}`;

    const foldersStorageKey =
        `liberiCuriosiArchivum_${childId}_${scope}`;


    React.useEffect(() => {
    if (workspaceMode !== "private") {
        return;
    }

    try {
        setNotes(
            localStorage.getItem(storageKey) ||
                ""
        );
    } catch {
        setNotes("");
    }
}, [storageKey, workspaceMode]);


React.useEffect(() => {
    try {
        const savedPages = JSON.parse(
            localStorage.getItem(
                notebookPagesStorageKey
            ) || "[]"
        );

        const validPages =
            Array.isArray(savedPages)
                ? savedPages
                : [];

        setNotebookPages(validPages);

        if (
            validPages.length > 0 &&
            !activeNotebookPageId
        ) {
            setActiveNotebookPageId(
                validPages[0].id
            );
        }
    } catch (error) {
        console.error(
            "Unable to load notebook pages:",
            error
        );

        setNotebookPages([]);
    }
}, [
    notebookPagesStorageKey,
    activeNotebookPageId,
]);
    React.useEffect(() => {
        if (
            workspaceMode !== "shared" ||
            activeWorkspace === "resources"
        ) {
            return undefined;
        }

        let isCancelled = false;
    sharedEpochRef.current += 1;
    sharedBusyRef.current = false;
    sharedSnapshotRef.current = "";
    const loadSharedWorkspace = async (initial = false) => {
        if (sharedBusyRef.current) return;
        if (initial) setSharedStatus("loading");
        setSharedError("");

        const epoch = sharedEpochRef.current;
        try {
            const workspace =
                await getSharedWorkspace({
                    childId,
                    scope,
                    workspaceType:
                        activeWorkspace ===
                        "whiteboard"
                            ? "tabula"
                            : "notepad",
                });

            if (isCancelled || sharedBusyRef.current || epoch !== sharedEpochRef.current) return;
            const snapshot = JSON.stringify(workspace);
            if (snapshot === sharedSnapshotRef.current) return;
            sharedSnapshotRef.current = snapshot;
            setSharedWorkspace(workspace);

            if (
                activeWorkspace ===
                "notepad"
            ) {
                setNotes(
                    workspace.notepad_html ||
                        ""
                );
            }

            setSharedStatus("loaded");
        } catch (error) {
            if (isCancelled) {
                return;
            }

            console.error(
                "Unable to load shared workspace:",
                error
            );

            setSharedError(
                error.response?.data?.detail ||
                    "Unable to open the shared workspace."
            );

            setSharedStatus("error");
        }
    };

    loadSharedWorkspace(true);
    const interval = window.setInterval(() => loadSharedWorkspace(), 1000);

    return () => {
        isCancelled = true;
        window.clearInterval(interval);
        window.clearTimeout(sharedSaveTimerRef.current);
    };
}, [
    childId,
    scope,
    workspaceMode,
    activeWorkspace,
]);

const recordingUrlRef =
    React.useRef("");

const chooseRecordingMimeType = (
    mode
) => {
    if (
        typeof MediaRecorder ===
        "undefined"
    ) {
        return "";
    }

    const candidateTypes =
        mode === "screen"
            ? [
                  "video/webm;codecs=vp9,opus",
                  "video/webm;codecs=vp8,opus",
                  "video/webm",
              ]
            : [
                  "audio/webm;codecs=opus",
                  "audio/webm",
                  "audio/ogg;codecs=opus",
              ];

    return (
        candidateTypes.find((type) =>
            MediaRecorder.isTypeSupported(
                type
            )
        ) || ""
    );
};

const stopRecording = () => {
    if (
        recordingTimerRef.current
    ) {
        window.clearInterval(
            recordingTimerRef.current
        );

        recordingTimerRef.current =
            null;
    }

    const recorder =
        mediaRecorderRef.current;

    if (
        !recorder ||
        recorder.state === "inactive"
    ) {
        setIsRecording(false);
        setIsRecordingPaused(false);

        return;
    }

    try {
        /*
         * Stopping the recorder automatically
         * delivers the final complete Blob through
         * ondataavailable before onstop runs.
         *
         * Do not call requestData here because that
         * can split the WebM into separate segments.
         */
        recorder.stop();
    } catch (error) {
        console.error(
            "Unable to stop recording:",
            error
        );

        setRecordingError(
            "The recording could not be stopped correctly."
        );

        setIsRecording(false);
        setIsRecordingPaused(false);
    }
};

const pauseRecording = () => {
    const recorder =
        mediaRecorderRef.current;

    if (
        !recorder ||
        recorder.state !==
            "recording"
    ) {
        return;
    }

    recorder.pause();
    setIsRecordingPaused(true);

    if (
        recordingTimerRef.current
    ) {
        window.clearInterval(
            recordingTimerRef.current
        );

        recordingTimerRef.current =
            null;
    }
};

const continueRecording = () => {
    const recorder =
        mediaRecorderRef.current;

    if (
        !recorder ||
        recorder.state !== "paused"
    ) {
        return;
    }

    recorder.resume();
    setIsRecordingPaused(false);

    if (
        recordingTimerRef.current
    ) {
        window.clearInterval(
            recordingTimerRef.current
        );
    }

    recordingTimerRef.current =
        window.setInterval(() => {
            setRecordingSeconds(
                (previousSeconds) =>
                    previousSeconds + 1
            );
        }, 1000);
};

const startRecording =
    async (mode) => {
        if (isRecording) {
            return;
        }

        if (
            typeof MediaRecorder ===
            "undefined"
        ) {
            setRecordingError(
                "This browser does not support recording."
            );

            return;
        }

        if (
            !navigator.mediaDevices
                ?.getUserMedia
        ) {
            setRecordingError(
                "Microphone access is not available in this browser."
            );

            return;
        }

        if (
            mode === "screen" &&
            !navigator.mediaDevices
                ?.getDisplayMedia
        ) {
            setRecordingError(
                "Screen recording is not available in this browser."
            );

            return;
        }

        let displayStream = null;
        let microphoneStream = null;

        setRecordingError("");
        setRecordingSeconds(0);
        setRecordingError("");
        setRecordingTitle("");
        setRecordingDescription("");
        setActiveVideoDraftId(null);
        setVideoDraftSaveMessage("");
        setActiveVideoDraftId(null);
        setVideoDraftSaveMessage("");   

        setEditorPlayhead(0);
        setEditorSegments([]);
        setEditorThumbnails([]);
        setIsEditorPreviewing(false);

        setRecordingSeconds(0);
        recordingElapsedMsRef.current = 0;
        setIsRecordingPaused(false);
        recordedChunksRef.current = [];

        try {
            let captureStream;

if (mode === "screen") {
    recordingWasExpandedRef.current =
        isExpanded;

    /*
     * Fill the browser tab with the workspace
     * before the user chooses the current tab.
     */
    setIsExpanded(true);

    await new Promise((resolve) => {
        window.requestAnimationFrame(() => {
            window.requestAnimationFrame(
                resolve
            );
        });
    });

    displayStream =
        await navigator
            .mediaDevices
            .getDisplayMedia({
                video: {
                    frameRate: 30,
                    displaySurface:
                        "browser",
                },
                audio: false,
                preferCurrentTab: true,
                selfBrowserSurface:
                    "include",
            });

    const screenTrack =
        displayStream
            .getVideoTracks()[0];

    if (!screenTrack) {
        throw new Error(
            "No browser-tab video was selected."
        );
    }

    microphoneStream =
    await navigator
        .mediaDevices
        .getUserMedia({
            video: false,
            audio: {
                echoCancellation:
                    true,
                noiseSuppression:
                    true,
                autoGainControl:
                    true,
            },
        });

microphoneStreamRef.current =
    microphoneStream;

const AudioContextClass =
    window.AudioContext ||
    window.webkitAudioContext;

if (!AudioContextClass) {
    throw new Error(
        "Audio recording is not supported in this browser."
    );
}

const audioContext =
    new AudioContextClass();

recordingAudioContextRef.current =
    audioContext;

if (
    audioContext.state ===
    "suspended"
) {
    await audioContext.resume();
}

const microphoneSource =
    audioContext
        .createMediaStreamSource(
            microphoneStream
        );

const microphoneGain =
    audioContext.createGain();

microphoneGain.gain.value = 1.25;

const audioDestination =
    audioContext
        .createMediaStreamDestination();

microphoneSource.connect(
    microphoneGain
);

microphoneGain.connect(
    audioDestination
);

const recordedAudioTracks =
    audioDestination.stream
        .getAudioTracks();

if (
    recordedAudioTracks.length === 0
) {
    throw new Error(
        "No microphone audio track was created."
    );
}

captureStream =
    new MediaStream([
        screenTrack,
        ...recordedAudioTracks,
    ]);

    screenTrack.addEventListener(
        "ended",
        stopRecording,
        {
            once: true,
        }
    );
} else {
                captureStream =
                    await navigator
                        .mediaDevices
                        .getUserMedia({
                            video: false,
                            audio: {
                                echoCancellation:
                                    true,
                                noiseSuppression:
                                    true,
                            },
                        });
            }

const recordingAudioTracks =
    captureStream.getAudioTracks();

if (
    recordingAudioTracks.length === 0
) {
    throw new Error(
        "No microphone track reached the recorder."
    );
}

recordingAudioTracks.forEach(
    (track) => {
        track.enabled = true;

        if (
            "contentHint" in track
        ) {
            track.contentHint =
                "speech";
        }
    }
);

recordingStreamRef.current =
    captureStream;

const selectedMimeType =
                chooseRecordingMimeType(
                    mode
                );

const recorderOptions = {
    audioBitsPerSecond: 128000,
    videoBitsPerSecond: 2500000,
};

if (selectedMimeType) {
    recorderOptions.mimeType =
        selectedMimeType;
}

const recorder =
    new MediaRecorder(
        captureStream,
        recorderOptions
    );

            mediaRecorderRef.current =
                recorder;

            recorder.ondataavailable = (
                event
            ) => {
                if (
                    event.data &&
                    event.data.size > 0
                ) {
                    recordedChunksRef.current.push(
                        event.data
                    );
                }
            };

            recorder.onerror = (
                event
            ) => {
                console.error(
                    "Recording error:",
                    event
                );

                setRecordingError(
                    "The recording stopped because of an error."
                );

                stopRecording();
            };

            recorder.onstop = async () => {
                if (
                    recordingTimerRef.current
                ) {
                    window.clearInterval(
                        recordingTimerRef.current
                    );

                    recordingTimerRef.current =
                        null;
                }

                const finalMimeType =
                    recorder.mimeType ||
                    selectedMimeType ||
                    (mode === "screen"
                        ? "video/webm"
                        : "audio/webm");

const recordingBlob =
    new Blob(
        recordedChunksRef.current,
        {
            type: finalMimeType,
        }
    );

let playableRecordingBlob =
    recordingBlob;

if (
    mode === "screen" &&
    recordingBlob.size > 0
) {
    try {
        playableRecordingBlob =
            await fixWebmDuration(
                recordingBlob,
                Math.max(
                    recordingElapsedMsRef.current,
                    1000
                ),
                {
                    logger: false,
                }
            );
    } catch (error) {
        console.error(
            "Unable to repair WebM duration metadata:",
            error
        );

        playableRecordingBlob =
            recordingBlob;
    }
}

if (
    playableRecordingBlob.size >
    0
) {
                    if (
                        recordingUrlRef.current
                    ) {
                        URL.revokeObjectURL(
                            recordingUrlRef.current
                        );
                    }

                    const nextUrl =
                        URL.createObjectURL(
                            playableRecordingBlob
                        );

                    recordingUrlRef.current =
                        nextUrl;

                    setRecordingUrl(
                        nextUrl
                    );

                    setRecordingMimeType(
                        finalMimeType
                    );

                    setRecordingError("");
                    setIsRecordingReviewOpen(true);
                } else {
                    setRecordingError(
                        "No recording data was captured."
                    );
                }

recordingStreamRef.current
    ?.getTracks()
    .forEach((track) =>
        track.stop()
    );

recordingStreamRef.current =
    null;

recordedChunksRef.current =
    [];

mediaRecorderRef.current =
    null;

setIsRecording(false);
setIsRecordingPaused(false);

microphoneStreamRef.current
    ?.getTracks()
    .forEach((track) =>
        track.stop()
    );

microphoneStreamRef.current =
    null;

if (
    recordingAudioContextRef.current &&
    recordingAudioContextRef.current
        .state !== "closed"
) {
    await recordingAudioContextRef.current
        .close();
}

recordingAudioContextRef.current =
    null;

if (
    !recordingWasExpandedRef.current
) {
    setIsExpanded(false);
}
            };

            recorder.start();

            setRecordingMode(mode);
            setIsRecording(true);

            recordingTimerRef.current =
                window.setInterval(() => {
                    recordingElapsedMsRef.current +=
                        1000;

            setRecordingSeconds(
                Math.floor(
                    recordingElapsedMsRef.current /
                        1000
                )
            );
                }, 1000);
        } catch (error) {
            displayStream
                ?.getTracks()
                .forEach((track) =>
                    track.stop()
                );

            microphoneStream
                ?.getTracks()
                .forEach((track) =>
                    track.stop()
                );

            recordingStreamRef.current
                ?.getTracks()
                .forEach((track) =>
                    track.stop()
                );

            recordingStreamRef.current =
                null;

            console.error(
                "Unable to start recording:",
                error
            );

            setIsRecording(false);

            if (
                !recordingWasExpandedRef.current
            ) {
                setIsExpanded(false);
            }

            setRecordingError(
                error?.name ===
                    "NotAllowedError"
                    ? "Recording permission was not granted."
                    : error?.message ||
                          "Unable to start recording."
            );
        }
    };

const downloadRecording = () => {
    if (!recordingUrl) {
        return;
    }

    const extension =
        recordingMimeType.includes(
            "mp4"
        )
            ? "mp4"
            : recordingMimeType.includes(
                    "ogg"
                )
              ? "ogg"
              : "webm";

    const recordingLabel =
        recordingMode === "screen"
            ? "screen-and-voice"
            : "voice";

    const timestamp =
        new Date()
            .toISOString()
            .replace(/[:.]/g, "-");

    const safeRecordingTitle =
        recordingTitle
            .trim()
            .replace(
                /[<>:"/\\|?*\u0000-\u001F]/g,
                "-"
            )
            .replace(/\s+/g, " ")
            .replace(/[. ]+$/g, "")
            .slice(0, 100);

    const downloadLink =
        document.createElement("a");

    downloadLink.href =
        recordingUrl;

    downloadLink.download =
        safeRecordingTitle
            ? `${safeRecordingTitle}.${extension}`
            : `liberi-curiosi-${recordingLabel}-${timestamp}.${extension}`;

    document.body.appendChild(
        downloadLink
    );

    downloadLink.click();
    downloadLink.remove();
};

const deleteRecording = () => {
    if (recordingUrlRef.current) {
        URL.revokeObjectURL(
            recordingUrlRef.current
        );

        recordingUrlRef.current =
            "";
    }

    setRecordingUrl("");
    setRecordingMimeType("");
    setRecordingMode(null);
    setRecordingSeconds(0);
    setRecordingError("");
    setIsRecordingReviewOpen(false);
};

const openRecordingEditor = () => {
    setEditorMuteOriginalAudio(false);
    setEditorTrimStart(0);
    setEditorTrimEnd(0);
    setEditorDuration(0);

    setIsRecordingReviewOpen(false);
    setIsRecordingEditorOpen(true);
};

const closeRecordingEditor = () => {
    const editorVideo =
        recordingEditorVideoRef.current;

    if (editorVideo) {
        editorVideo.pause();
    }

    setIsRecordingEditorOpen(false);
    setIsRecordingReviewOpen(true);
};

const formatRecordingTime = (
    totalSeconds
) => {
    const safeSeconds = Math.max(
        0,
        Math.floor(
            Number(totalSeconds) || 0
        )
    );

    const minutes = Math.floor(
        safeSeconds / 60
    );

    const seconds =
        safeSeconds % 60;

    return `${String(minutes).padStart(
        2,
        "0"
    )}:${String(seconds).padStart(
        2,
        "0"
    )}`;
};

const formatEditorTimestamp = (
    totalSeconds
) => {


    const safeSeconds = Math.max(
        0,
        Number(totalSeconds) || 0
    );

    const minutes = Math.floor(
        safeSeconds / 60
    );

    const seconds = (
        safeSeconds % 60
    ).toFixed(1);

    return `${minutes}:${seconds.padStart(
        4,
        "0"
    )}`;
};

const generateRecordingThumbnails =
    async (videoUrl, duration) => {
        if (
            !videoUrl ||
            !Number.isFinite(duration) ||
            duration <= 0
        ) {
            setEditorThumbnails([]);
            return;
        }

        const generationId =
            editorThumbnailGenerationRef
                .current + 1;

        editorThumbnailGenerationRef.current =
            generationId;

        setIsGeneratingEditorThumbnails(
            true
        );

        const previewVideo =
            document.createElement(
                "video"
            );

        previewVideo.muted = true;
        previewVideo.playsInline = true;
        previewVideo.preload = "auto";
        previewVideo.src = videoUrl;

        const waitForVideoEvent = (
            eventName
        ) =>
            new Promise(
                (resolve, reject) => {
                    const handleReady =
                        () => {
                            cleanup();
                            resolve();
                        };

                    const handleError =
                        () => {
                            cleanup();

                            reject(
                                new Error(
                                    `Unable to read video ${eventName}.`
                                )
                            );
                        };

                    const cleanup = () => {
                        previewVideo.removeEventListener(
                            eventName,
                            handleReady
                        );

                        previewVideo.removeEventListener(
                            "error",
                            handleError
                        );
                    };

                    previewVideo.addEventListener(
                        eventName,
                        handleReady,
                        {
                            once: true,
                        }
                    );

                    previewVideo.addEventListener(
                        "error",
                        handleError,
                        {
                            once: true,
                        }
                    );
                }
            );

        const seekToTime = (
            nextTime
        ) =>
            new Promise(
                (resolve, reject) => {
                    const handleSeeked =
                        () => {
                            cleanup();
                            resolve();
                        };

                    const handleError =
                        () => {
                            cleanup();

                            reject(
                                new Error(
                                    "Unable to seek while creating video slides."
                                )
                            );
                        };

                    const cleanup = () => {
                        previewVideo.removeEventListener(
                            "seeked",
                            handleSeeked
                        );

                        previewVideo.removeEventListener(
                            "error",
                            handleError
                        );
                    };

                    previewVideo.addEventListener(
                        "seeked",
                        handleSeeked,
                        {
                            once: true,
                        }
                    );

                    previewVideo.addEventListener(
                        "error",
                        handleError,
                        {
                            once: true,
                        }
                    );

                    previewVideo.currentTime =
                        nextTime;
                }
            );

        try {
            if (
                previewVideo.readyState < 1
            ) {
                await waitForVideoEvent(
                    "loadedmetadata"
                );
            }

            const canvas =
                document.createElement(
                    "canvas"
                );

            const context =
                canvas.getContext("2d");

            if (!context) {
                throw new Error(
                    "Unable to create video slides."
                );
            }

            const videoWidth =
                previewVideo.videoWidth ||
                16;

            const videoHeight =
                previewVideo.videoHeight ||
                9;

            canvas.width = 180;

            canvas.height = Math.max(
                90,
                Math.round(
                    canvas.width *
                        (videoHeight /
                            videoWidth)
                )
            );

            const sampleCount = Math.min(
                10,
                Math.max(
                    6,
                    Math.ceil(
                        duration / 2
                    )
                )
            );

            const maxSeekTime =
                Math.max(
                    0,
                    duration - 0.08
                );

            const nextThumbnails = [];

            for (
                let index = 0;
                index < sampleCount;
                index += 1
            ) {
                if (
                    editorThumbnailGenerationRef
                        .current !==
                    generationId
                ) {
                    return;
                }

                const rawTime =
                    sampleCount === 1
                        ? 0
                        : (duration *
                              index) /
                          (sampleCount -
                              1);

                const thumbnailTime =
                    Math.min(
                        maxSeekTime,
                        Math.max(
                            0,
                            rawTime
                        )
                    );

                await seekToTime(
                    thumbnailTime
                );

                context.drawImage(
                    previewVideo,
                    0,
                    0,
                    canvas.width,
                    canvas.height
                );

                nextThumbnails.push({
                    id: `thumbnail-${generationId}-${index}`,
                    time: thumbnailTime,
                    image: canvas.toDataURL(
                        "image/jpeg",
                        0.72
                    ),
                });
            }

            if (
                editorThumbnailGenerationRef
                    .current ===
                generationId
            ) {
                setEditorThumbnails(
                    nextThumbnails
                );
            }
        } catch (error) {
            console.error(
                "Unable to generate recording slides:",
                error
            );

            if (
                editorThumbnailGenerationRef
                    .current ===
                generationId
            ) {
                setEditorThumbnails([]);
            }
        } finally {
            if (
                editorThumbnailGenerationRef
                    .current ===
                generationId
            ) {
                setIsGeneratingEditorThumbnails(
                    false
                );
            }

            previewVideo.removeAttribute(
                "src"
            );

            previewVideo.load();
        }
    };
const handleRecordingEditorLoaded = (
    event
) => {
    const editorVideo =
        event.currentTarget;

    const reportedDuration =
        Number.isFinite(
            editorVideo.duration
        ) &&
        editorVideo.duration > 0
            ? editorVideo.duration
            : 0;

    const seekableDuration =
        editorVideo.seekable.length > 0
            ? editorVideo.seekable.end(
                  editorVideo.seekable
                      .length - 1
              )
            : 0;

    const duration = Math.max(
        reportedDuration,
        seekableDuration,
        recordingSeconds
    );

    setEditorDuration(duration);
    setEditorTrimStart(0);
    setEditorTrimEnd(duration);
    setEditorPlayhead(0);

    setEditorSegments(
        (currentSegments) => {
            const previousDuration =
                currentSegments.length > 0
                    ? currentSegments[
                          currentSegments.length -
                              1
                      ].end
                    : 0;

            if (
                currentSegments.length >
                    0 &&
                Math.abs(
                    previousDuration -
                        duration
                ) < 0.25
            ) {
                return currentSegments;
            }

            return [
                {
                    id: `segment-${Date.now()}`,
                    start: 0,
                    end: duration,
                    deleted: false,
                },
            ];
        }
    );

    editorVideo.currentTime = 0;

    void generateRecordingThumbnails(
        editorVideo.currentSrc ||
            recordingUrl,
        duration
    );
};

const resetRecordingPlayerToStart = (
    event
) => {
    const video =
        event.currentTarget;

    video.pause();

    try {
        video.currentTime = 0;
    } catch (error) {
        console.error(
            "Unable to reset recording playback:",
            error
        );
    }

    window.requestAnimationFrame(() => {
        try {
            video.currentTime = 0;
        } catch (error) {
            console.error(
                "Unable to finish resetting recording playback:",
                error
            );
        }
    });
};

const previewRecordingSelection = () => {
    const editorVideo =
        recordingEditorVideoRef.current;

    if (!editorVideo) {
        return;
    }

    const keptSegments =
        editorSegments
            .filter(
                (segment) =>
                    !segment.deleted
            )
            .sort(
                (
                    firstSegment,
                    secondSegment
                ) =>
                    firstSegment.start -
                    secondSegment.start
            );

    if (keptSegments.length === 0) {
        setRecordingError(
            "Restore at least one video section before previewing."
        );

        return;
    }

    setRecordingError("");

    editorVideo.pause();

    editorVideo.currentTime =
        keptSegments[0].start;

    editorVideo.muted =
        editorMuteOriginalAudio;

    setEditorPlayhead(
        keptSegments[0].start
    );

    setIsEditorPreviewing(true);

    void editorVideo
        .play()
        .catch((error) => {
            console.error(
                "Unable to preview edited recording:",
                error
            );

            setIsEditorPreviewing(
                false
            );
        });
};

const previewSelectedRecordingRange =
    () => {
        const editorVideo =
            recordingEditorVideoRef.current;

        if (!editorVideo) {
            return;
        }

        const selectionStart =
            Math.min(
                editorTrimStart,
                editorTrimEnd
            );

        const selectionEnd =
            Math.max(
                editorTrimStart,
                editorTrimEnd
            );

        if (
            selectionEnd -
                selectionStart <
            0.15
        ) {
            setRecordingError(
                "Move the two selection handles farther apart."
            );

            return;
        }

        editorVideo.pause();

        editorVideo.currentTime =
            selectionStart;

        // Selected-section preview always
        // plays the original audio.
        editorVideo.muted = false;

        selectedRangePreviewEndRef.current =
            selectionEnd;

        setEditorPlayhead(
            selectionStart
        );

        setIsEditorPreviewing(false);

        setIsSelectedRangePreviewing(
            true
        );

        setRecordingError("");

        void editorVideo
            .play()
            .catch((error) => {
                console.error(
                    "Unable to preview selected recording section:",
                    error
                );

                setIsSelectedRangePreviewing(
                    false
                );

                selectedRangePreviewEndRef.current =
                    null;
            });
    };

const handleRecordingEditorTimeUpdate =
    () => {
        const editorVideo =
            recordingEditorVideoRef
                .current;

        if (!editorVideo) {
            return;
        }

        const currentTime =
            editorVideo.currentTime;

setEditorPlayhead(
    currentTime
);

if (isSelectedRangePreviewing) {
    const selectionEnd =
        selectedRangePreviewEndRef.current;

    if (
        Number.isFinite(
            selectionEnd
        ) &&
        currentTime >=
            selectionEnd - 0.025
    ) {
        editorVideo.pause();

        editorVideo.currentTime =
            selectionEnd;

        setEditorPlayhead(
            selectionEnd
        );

        setIsSelectedRangePreviewing(
            false
        );

        selectedRangePreviewEndRef.current =
            null;
    }

    return;
}

if (!isEditorPreviewing) {
    return;
}

        const orderedSegments =
            [...editorSegments].sort(
                (
                    firstSegment,
                    secondSegment
                ) =>
                    firstSegment.start -
                    secondSegment.start
            );

        const deletedSegment =
            orderedSegments.find(
                (segment) =>
                    segment.deleted &&
                    currentTime >=
                        segment.start &&
                    currentTime <
                        segment.end
            );

        if (deletedSegment) {
            const nextKeptSegment =
                orderedSegments.find(
                    (segment) =>
                        !segment.deleted &&
                        segment.start >=
                            deletedSegment.end -
                                0.02
                );

            if (nextKeptSegment) {
                editorVideo.currentTime =
                    nextKeptSegment.start;

                return;
            }

            editorVideo.pause();
            setIsEditorPreviewing(
                false
            );

            return;
        }

        const keptSegments =
            orderedSegments.filter(
                (segment) =>
                    !segment.deleted
            );

        const finalKeptSegment =
            keptSegments[
                keptSegments.length - 1
            ];

        if (
            finalKeptSegment &&
            currentTime >=
                finalKeptSegment.end -
                    0.03
        ) {
            editorVideo.pause();

            editorVideo.currentTime =
                finalKeptSegment.end;

            setEditorPlayhead(
                finalKeptSegment.end
            );

            setIsEditorPreviewing(
                false
            );
        }
    };

const seekRecordingEditorTo = (
    nextTime
) => {
    const editorVideo =
        recordingEditorVideoRef.current;

    const safeTime = Math.max(
        0,
        Math.min(
            Number(nextTime) || 0,
            editorDuration
        )
    );

    if (editorVideo) {
        editorVideo.pause();
        editorVideo.currentTime =
            safeTime;
    }

    setIsEditorPreviewing(false);
    setEditorPlayhead(safeTime);
};

const splitRecordingAtPlayhead =
    () => {
        setEditorSegments(
            (currentSegments) => {
                const targetIndex =
                    currentSegments.findIndex(
                        (segment) =>
                            editorPlayhead >
                                segment.start +
                                    0.15 &&
                            editorPlayhead <
                                segment.end -
                                    0.15
                    );

                if (targetIndex < 0) {
                    return currentSegments;
                }

                const targetSegment =
                    currentSegments[
                        targetIndex
                    ];

                const timestamp =
                    Date.now();

                const firstHalf = {
                    ...targetSegment,
                    id: `${targetSegment.id}-a-${timestamp}`,
                    end: editorPlayhead,
                };

                const secondHalf = {
                    ...targetSegment,
                    id: `${targetSegment.id}-b-${timestamp}`,
                    start: editorPlayhead,
                };

                return [
                    ...currentSegments.slice(
                        0,
                        targetIndex
                    ),
                    firstHalf,
                    secondHalf,
                    ...currentSegments.slice(
                        targetIndex + 1
                    ),
                ];
            }
        );
    };

const toggleRecordingSegmentDeleted = (
    segmentId
) => {
    setEditorSegments(
        (currentSegments) =>
            currentSegments.map(
                (segment) =>
                    segment.id ===
                    segmentId
                        ? {
                              ...segment,
                              deleted:
                                  !segment.deleted,
                          }
                        : segment
            )
    );
};

const removeSelectedRecordingRange =
    () => {
        const cutStart = Math.min(
            editorTrimStart,
            editorTrimEnd
        );

        const cutEnd = Math.max(
            editorTrimStart,
            editorTrimEnd
        );

        if (
            cutEnd - cutStart <
            0.15
        ) {
            setRecordingError(
                "Move the two cut handles farther apart."
            );

            return;
        }

        const timestamp =
            Date.now();

        setEditorSegments(
            (currentSegments) =>
                currentSegments.flatMap(
                    (
                        segment,
                        segmentIndex
                    ) => {
                        if (
                            segment.deleted ||
                            cutEnd <=
                                segment.start ||
                            cutStart >=
                                segment.end
                        ) {
                            return [
                                segment,
                            ];
                        }

                        const overlapStart =
                            Math.max(
                                cutStart,
                                segment.start
                            );

                        const overlapEnd =
                            Math.min(
                                cutEnd,
                                segment.end
                            );

                        const nextPieces =
                            [];

                        if (
                            overlapStart -
                                segment.start >
                            0.05
                        ) {
                            nextPieces.push({
                                ...segment,
                                id: `${segment.id}-left-${timestamp}-${segmentIndex}`,
                                end: overlapStart,
                                deleted: false,
                            });
                        }

                        nextPieces.push({
                            ...segment,
                            id: `${segment.id}-removed-${timestamp}-${segmentIndex}`,
                            start: overlapStart,
                            end: overlapEnd,
                            deleted: true,
                        });

                        if (
                            segment.end -
                                overlapEnd >
                            0.05
                        ) {
                            nextPieces.push({
                                ...segment,
                                id: `${segment.id}-right-${timestamp}-${segmentIndex}`,
                                start: overlapEnd,
                                deleted: false,
                            });
                        }

                        return nextPieces;
                    }
                )
        );

        const editorVideo =
            recordingEditorVideoRef
                .current;

        if (editorVideo) {
            editorVideo.pause();
            editorVideo.currentTime =
                cutStart;
        }

        setEditorPlayhead(cutStart);
        setIsEditorPreviewing(false);
        setRecordingError("");
    };

const restoreAllRecordingCuts =
    () => {
        const fullDuration =
            Math.max(
                editorDuration,
                recordingSeconds,
                0
            );

        if (fullDuration <= 0) {
            setRecordingError(
                "The recording duration is not available yet."
            );

            return;
        }

        setEditorSegments([
            {
                id: `segment-restored-${Date.now()}`,
                start: 0,
                end: fullDuration,
                deleted: false,
            },
        ]);

        setEditorTrimStart(0);
        setEditorTrimEnd(fullDuration);
        setEditorPlayhead(0);
        setIsEditorPreviewing(false);
        setRecordingError("");

        const editorVideo =
            recordingEditorVideoRef.current;

        if (editorVideo) {
            editorVideo.pause();
            editorVideo.currentTime = 0;
        }
    };

const renderRecordingEdits = async () => {
    const keptSegments =
        editorSegments
            .filter(
                (segment) =>
                    !segment.deleted &&
                    segment.end >
                        segment.start
            )
            .sort(
                (
                    firstSegment,
                    secondSegment
                ) =>
                    firstSegment.start -
                    secondSegment.start
            );

    if (keptSegments.length === 0) {
        setRecordingError(
            "Restore or keep at least one video section before saving."
        );

        return;
    }

    if (!recordingUrl) {
        setRecordingError(
            "The original recording is not available."
        );

        return;
    }

    const editedDuration =
        keptSegments.reduce(
            (total, segment) =>
                total +
                Math.max(
                    0,
                    segment.end -
                        segment.start
                ),
            0
        );

    if (editedDuration <= 0) {
        setRecordingError(
            "The edited recording has no playable footage."
        );

        return;
    }

    const renderVideo =
        document.createElement("video");

    let captureStream = null;

    const waitForVideoEvent = (
        eventName
    ) =>
        new Promise(
            (resolve, reject) => {
                const handleReady =
                    () => {
                        cleanup();
                        resolve();
                    };

                const handleError =
                    () => {
                        cleanup();

                        reject(
                            new Error(
                                "The recording could not be prepared for editing."
                            )
                        );
                    };

                const cleanup = () => {
                    renderVideo.removeEventListener(
                        eventName,
                        handleReady
                    );

                    renderVideo.removeEventListener(
                        "error",
                        handleError
                    );
                };

                renderVideo.addEventListener(
                    eventName,
                    handleReady,
                    {
                        once: true,
                    }
                );

                renderVideo.addEventListener(
                    "error",
                    handleError,
                    {
                        once: true,
                    }
                );
            }
        );

    const seekRenderVideo = (
        nextTime
    ) =>
        new Promise(
            (resolve, reject) => {
                const safeTime =
                    Math.max(
                        0,
                        Math.min(
                            Number(
                                nextTime
                            ) || 0,
                            renderVideo
                                .duration || 0
                        )
                    );

                if (
                    Math.abs(
                        renderVideo.currentTime -
                            safeTime
                    ) < 0.02
                ) {
                    resolve();
                    return;
                }

                const handleSeeked =
                    () => {
                        cleanup();
                        resolve();
                    };

                const handleError =
                    () => {
                        cleanup();

                        reject(
                            new Error(
                                "The edited recording could not seek to the selected section."
                            )
                        );
                    };

                const cleanup = () => {
                    renderVideo.removeEventListener(
                        "seeked",
                        handleSeeked
                    );

                    renderVideo.removeEventListener(
                        "error",
                        handleError
                    );
                };

                renderVideo.addEventListener(
                    "seeked",
                    handleSeeked,
                    {
                        once: true,
                    }
                );

                renderVideo.addEventListener(
                    "error",
                    handleError,
                    {
                        once: true,
                    }
                );

                renderVideo.currentTime =
                    safeTime;
            }
        );

    const playUntil = (
        endTime
    ) =>
        new Promise(
            (resolve, reject) => {
                let animationFrameId =
                    null;

                const cleanup = () => {
                    if (
                        animationFrameId !==
                        null
                    ) {
                        window.cancelAnimationFrame(
                            animationFrameId
                        );
                    }

                    renderVideo.removeEventListener(
                        "error",
                        handleError
                    );
                };

                const finish = () => {
                    renderVideo.pause();
                    cleanup();
                    resolve();
                };

                const handleError =
                    () => {
                        cleanup();

                        reject(
                            new Error(
                                "The edited recording stopped while rendering."
                            )
                        );
                    };

                const checkPosition =
                    () => {
                        if (
                            renderVideo.ended ||
                            renderVideo
                                .currentTime >=
                                endTime -
                                    0.025
                        ) {
                            finish();
                            return;
                        }

                        animationFrameId =
                            window.requestAnimationFrame(
                                checkPosition
                            );
                    };

                renderVideo.addEventListener(
                    "error",
                    handleError,
                    {
                        once: true,
                    }
                );

                renderVideo
                    .play()
                    .then(() => {
                        checkPosition();
                    })
                    .catch((error) => {
                        cleanup();
                        reject(error);
                    });
            }
        );

    const waitForRecorderEvent = (
        recorder,
        eventName
    ) =>
        new Promise((resolve) => {
            recorder.addEventListener(
                eventName,
                resolve,
                {
                    once: true,
                }
            );
        });

    try {
        setIsRenderingEditedRecording(
            true
        );

        setRecordingError("");

        const currentEditorVideo =
            recordingEditorVideoRef
                .current;

        if (currentEditorVideo) {
            currentEditorVideo.pause();
        }

        renderVideo.src =
            recordingUrl;

        renderVideo.preload = "auto";
        renderVideo.playsInline = true;

        renderVideo.muted =
            editorMuteOriginalAudio;

        renderVideo.volume =
            editorMuteOriginalAudio
                ? 0
                : 1;

        renderVideo.style.position =
            "fixed";

        renderVideo.style.left = "0";
        renderVideo.style.top = "0";
        renderVideo.style.width = "640px";
        renderVideo.style.height = "360px";
        renderVideo.style.opacity =
            "0.001";
        renderVideo.style.zIndex = "-1";
        renderVideo.style.pointerEvents =
            "none";

        document.body.appendChild(
            renderVideo
        );

        if (renderVideo.readyState < 2) {
            await waitForVideoEvent(
                "loadeddata"
            );
        }

        await seekRenderVideo(
            keptSegments[0].start
        );

        const captureFunction =
            renderVideo.captureStream ||
            renderVideo.mozCaptureStream;

        if (!captureFunction) {
            throw new Error(
                "This browser does not support rendering edited recordings."
            );
        }

        captureStream =
            captureFunction.call(
                renderVideo
            );

        if (
            editorMuteOriginalAudio
        ) {
            captureStream
                .getAudioTracks()
                .forEach((track) => {
                    captureStream.removeTrack(
                        track
                    );

                    track.stop();
                });
        }

        const selectedMimeType =
            chooseRecordingMimeType(
                "screen"
            ) ||
            recordingMimeType ||
            "video/webm";

        const recorderOptions = {
            audioBitsPerSecond: 128000,
            videoBitsPerSecond: 2500000,
        };

        if (
            selectedMimeType &&
            MediaRecorder.isTypeSupported(
                selectedMimeType
            )
        ) {
            recorderOptions.mimeType =
                selectedMimeType;
        }

        const editedRecorder =
            new MediaRecorder(
                captureStream,
                recorderOptions
            );

        const editedChunks = [];

        editedRecorder.ondataavailable =
            (event) => {
                if (
                    event.data &&
                    event.data.size > 0
                ) {
                    editedChunks.push(
                        event.data
                    );
                }
            };

        const editedRecordingPromise =
            new Promise(
                (resolve, reject) => {
                    editedRecorder.addEventListener(
                        "stop",
                        () => {
                            const finalMimeType =
                                editedRecorder.mimeType ||
                                selectedMimeType ||
                                "video/webm";

                            resolve({
                                blob: new Blob(
                                    editedChunks,
                                    {
                                        type: finalMimeType,
                                    }
                                ),
                                mimeType:
                                    finalMimeType,
                            });
                        },
                        {
                            once: true,
                        }
                    );

                    editedRecorder.addEventListener(
                        "error",
                        (event) => {
                            reject(
                                event.error ||
                                    new Error(
                                        "Unable to render the edited recording."
                                    )
                            );
                        },
                        {
                            once: true,
                        }
                    );
                }
            );

        editedRecorder.start(250);

        for (
            let index = 0;
            index <
            keptSegments.length;
            index += 1
        ) {
            const segment =
                keptSegments[index];

if (index > 0) {
    renderVideo.pause();

    await seekRenderVideo(
        segment.start
    );
}

await playUntil(
    segment.end
);
        }

renderVideo.pause();

if (
    editedRecorder.state ===
    "recording"
) {
    editedRecorder.requestData();

    await new Promise(
        (resolve) => {
            window.setTimeout(
                resolve,
                500
            );
        }
    );
}

if (
    editedRecorder.state !==
    "inactive"
) {
    editedRecorder.stop();
}
        const {
            blob: rawEditedBlob,
            mimeType:
                finalEditedMimeType,
        } =
            await editedRecordingPromise;

        if (
            !rawEditedBlob ||
            rawEditedBlob.size === 0
        ) {
            throw new Error(
                "The edited recording contained no video data."
            );
        }

        let playableEditedBlob =
            rawEditedBlob;

        try {
            playableEditedBlob =
                await fixWebmDuration(
                    rawEditedBlob,
                    Math.max(
                        editedDuration *
                            1000,
                        1000
                    ),
                    {
                        logger: false,
                    }
                );
        } catch (error) {
            console.error(
                "Unable to repair edited WebM duration:",
                error
            );

            playableEditedBlob =
                rawEditedBlob;
        }

        const previousUrl =
            recordingUrlRef.current;

        const nextUrl =
            URL.createObjectURL(
                playableEditedBlob
            );

        recordingUrlRef.current =
            nextUrl;

        setRecordingUrl(nextUrl);

        setRecordingMimeType(
            finalEditedMimeType
        );

        setRecordingSeconds(
            Math.max(
                1,
                Math.round(
                    editedDuration
                )
            )
        );

        recordingElapsedMsRef.current =
            Math.max(
                1000,
                Math.round(
                    editedDuration *
                        1000
                )
            );

        setEditorDuration(
            editedDuration
        );

        setEditorTrimStart(0);

        setEditorTrimEnd(
            editedDuration
        );

        setEditorPlayhead(0);

        setEditorSegments([
            {
                id: `segment-edited-${Date.now()}`,
                start: 0,
                end: editedDuration,
                deleted: false,
            },
        ]);

        setEditorThumbnails([]);

        setEditorMuteOriginalAudio(
            false
        );

        setIsEditorPreviewing(false);
        setIsRecordingEditorOpen(false);
        setIsRecordingReviewOpen(true);
        setRecordingError("");

        if (
            previousUrl &&
            previousUrl !== nextUrl
        ) {
            URL.revokeObjectURL(
                previousUrl
            );
        }
    } catch (error) {
        console.error(
            "Unable to save edited recording:",
            error
        );

        setRecordingError(
            error?.message ||
                "Unable to save the edited recording."
        );
    } finally {
        renderVideo.pause();

        renderVideo.removeAttribute(
            "src"
        );

        renderVideo.load();
        renderVideo.remove();

        captureStream
            ?.getTracks()
            .forEach((track) =>
                track.stop()
            );

        setIsRenderingEditedRecording(
            false
        );
    }
};

const openVideoDraftDatabase = () =>
    new Promise((resolve, reject) => {
        if (
            typeof window === "undefined" ||
            !window.indexedDB
        ) {
            reject(
                new Error(
                    "This browser does not support local video drafts."
                )
            );

            return;
        }

        const request =
            window.indexedDB.open(
                "liberiCuriosiVideoDrafts",
                1
            );

        request.onupgradeneeded = () => {
            const database =
                request.result;

            if (
                !database.objectStoreNames.contains(
                    "videoDrafts"
                )
            ) {
                const store =
                    database.createObjectStore(
                        "videoDrafts",
                        {
                            keyPath: "id",
                        }
                    );

                store.createIndex(
                    "childScope",
                    "childScope",
                    {
                        unique: false,
                    }
                );

                store.createIndex(
                    "updatedAt",
                    "updatedAt",
                    {
                        unique: false,
                    }
                );
            }
        };

        request.onsuccess = () => {
            resolve(request.result);
        };

        request.onerror = () => {
            reject(
                request.error ||
                    new Error(
                        "Unable to open video draft storage."
                    )
            );
        };

        request.onblocked = () => {
            reject(
                new Error(
                    "Video draft storage is blocked by another open app window."
                )
            );
        };
    });

const putVideoDraftInDatabase =
    async (draft) => {
        const database =
            await openVideoDraftDatabase();

        try {
            await new Promise(
                (resolve, reject) => {
                    const transaction =
                        database.transaction(
                            "videoDrafts",
                            "readwrite"
                        );

                    transaction.oncomplete =
                        () => {
                            resolve();
                        };

                    transaction.onerror =
                        () => {
                            reject(
                                transaction.error ||
                                    new Error(
                                        "Unable to save the video draft."
                                    )
                            );
                        };

                    transaction.onabort =
                        () => {
                            reject(
                                transaction.error ||
                                    new Error(
                                        "Saving the video draft was cancelled."
                                    )
                            );
                        };

                    transaction
                        .objectStore(
                            "videoDrafts"
                        )
                        .put(draft);
                }
            );
        } finally {
            database.close();
        }
    };

const deleteVideoDraftFromDatabase =
    async (draftId) => {
        const database =
            await openVideoDraftDatabase();

        try {
            await new Promise(
                (resolve, reject) => {
                    const transaction =
                        database.transaction(
                            "videoDrafts",
                            "readwrite"
                        );

                    const store =
                        transaction.objectStore(
                            "videoDrafts"
                        );

                    const request =
                        store.delete(
                            draftId
                        );

                    request.onerror =
                        () => {
                            reject(
                                request.error ||
                                    new Error(
                                        "Unable to delete the video draft."
                                    )
                            );
                        };

                    transaction.oncomplete =
                        () => {
                            resolve();
                        };

                    transaction.onerror =
                        () => {
                            reject(
                                transaction.error ||
                                    new Error(
                                        "Unable to finish deleting the video draft."
                                    )
                            );
                        };
                }
            );
        } finally {
            database.close();
        }
    };

const getVideoDraftsFromDatabase =
    async () => {
        const database =
            await openVideoDraftDatabase();

        try {
            return await new Promise(
                (resolve, reject) => {
                    const transaction =
                        database.transaction(
                            "videoDrafts",
                            "readonly"
                        );

                    const store =
                        transaction.objectStore(
                            "videoDrafts"
                        );

                    const childScopeIndex =
                        store.index(
                            "childScope"
                        );

                    const currentChildScope = `${
                        childId ||
                        "unknown-child"
                    }::${
                        scope ||
                        "dashboard"
                    }`;

                    const request =
                        childScopeIndex.getAll(
                            currentChildScope
                        );

                    request.onsuccess =
                        () => {
                            const savedDrafts =
                                Array.isArray(
                                    request.result
                                )
                                    ? request.result
                                    : [];

                            resolve(
                                savedDrafts.sort(
                                    (
                                        firstDraft,
                                        secondDraft
                                    ) =>
                                        new Date(
                                            secondDraft.updatedAt ||
                                                secondDraft.createdAt ||
                                                0
                                        ).getTime() -
                                        new Date(
                                            firstDraft.updatedAt ||
                                                firstDraft.createdAt ||
                                                0
                                        ).getTime()
                                )
                            );
                        };

                    request.onerror =
                        () => {
                            reject(
                                request.error ||
                                    new Error(
                                        "Unable to load video drafts."
                                    )
                            );
                        };
                }
            );
        } finally {
            database.close();
        }
    };

const loadVideoDrafts =
    async () => {
        try {
            setIsLoadingVideoDrafts(
                true
            );

            setRecordingError("");

            const savedDrafts =
                await getVideoDraftsFromDatabase();

            setVideoDrafts(
                savedDrafts
            );
        } catch (error) {
            console.error(
                "Unable to load video drafts:",
                error
            );

            setVideoDrafts([]);

            setRecordingError(
                error?.message ||
                    "Unable to load video drafts."
            );
        } finally {
            setIsLoadingVideoDrafts(
                false
            );
        }
    };
const openVideoDraftsPanel =
    async () => {
        setIsVideoDraftsOpen(true);

        await loadVideoDrafts();
    };

const closeVideoDraftsPanel =
    () => {
        setIsVideoDraftsOpen(false);
    };     
const continueEditingVideoDraft =
    (draft) => {
        if (
            !draft ||
            !(draft.sourceBlob instanceof Blob)
        ) {
            setRecordingError(
                "This video draft does not contain a usable recording."
            );

            return;
        }

        const previousUrl =
            recordingUrlRef.current;

        const nextUrl =
            URL.createObjectURL(
                draft.sourceBlob
            );

        const restoredDuration =
            Math.max(
                0,
                Number(
                    draft.sourceDuration ||
                        draft.editorDuration ||
                        0
                )
            );

        const restoredSegments =
            Array.isArray(draft.segments)
                ? draft.segments
                : Array.isArray(
                      draft.editorSegments
                  )
                  ? draft.editorSegments
                  : [];

        recordingUrlRef.current =
            nextUrl;

        setRecordingUrl(nextUrl);

        setRecordingMimeType(
            draft.recordingMimeType ||
                draft.sourceBlob.type ||
                "video/webm"
        );

        setRecordingMode(
            draft.recordingMode ||
                "screen"
        );

        setRecordingTitle(
            draft.title || ""
        );

        setRecordingDescription(
            draft.description || ""
        );

        setRecordingSeconds(
            Math.max(
                0,
                Math.round(
                    restoredDuration
                )
            )
        );

        recordingElapsedMsRef.current =
            Math.max(
                0,
                Math.round(
                    restoredDuration *
                        1000
                )
            );

        setActiveVideoDraftId(
            draft.id
        );

        setVideoDraftSaveMessage("");

        setEditorDuration(
            restoredDuration
        );

        setEditorTrimStart(0);

        setEditorTrimEnd(
            restoredDuration
        );

        setEditorPlayhead(0);

        setEditorSegments(
            restoredSegments.length > 0
                ? restoredSegments
                : restoredDuration > 0
                  ? [
                        {
                            id: `segment-draft-${Date.now()}`,
                            start: 0,
                            end: restoredDuration,
                            deleted: false,
                        },
                    ]
                  : []
        );

        setEditorMuteOriginalAudio(
            Boolean(
                draft.muteOriginalAudio ??
                    draft.editorMuteOriginalAudio ??
                    false
            )
        );

        setEditorThumbnails([]);

        setIsEditorPreviewing(false);

        setIsSelectedRangePreviewing(
            false
        );

        selectedRangePreviewEndRef.current =
            null;

        setRecordingError("");

        setIsRecordingReviewOpen(false);

        setIsVideoDraftsOpen(false);

        setIsRecordingEditorOpen(true);

        if (
            previousUrl &&
            previousUrl !== nextUrl
        ) {
            URL.revokeObjectURL(
                previousUrl
            );
        }
    };       
const downloadVideoDraftOriginal =
    (draft) => {
        if (
            !draft ||
            !(draft.sourceBlob instanceof Blob)
        ) {
            setRecordingError(
                "This video draft does not contain a downloadable recording."
            );

            return;
        }

        const downloadUrl =
            URL.createObjectURL(
                draft.sourceBlob
            );

        const safeTitle =
            String(
                draft.title ||
                    "video-draft"
            )
                .trim()
                .replace(
                    /[^a-z0-9-_]+/gi,
                    "-"
                )
                .replace(
                    /^-+|-+$/g,
                    ""
                ) || "video-draft";

        const fileExtension =
            draft.sourceBlob.type.includes(
                "mp4"
            )
                ? "mp4"
                : "webm";

        const downloadLink =
            document.createElement(
                "a"
            );

        downloadLink.href =
            downloadUrl;

        downloadLink.download =
            `${safeTitle}.${fileExtension}`;

        document.body.appendChild(
            downloadLink
        );

        downloadLink.click();

        downloadLink.remove();

        window.setTimeout(() => {
            URL.revokeObjectURL(
                downloadUrl
            );
        }, 1000);
    };    

const deleteSavedVideoDraft =
    (draft) => {
        if (!draft?.id) {
            setRecordingError(
                "This video draft could not be identified."
            );

            return;
        }

        setRecordingError("");

        setPendingVideoDraftDelete(
            draft
        );
    };

const cancelVideoDraftDelete =
    () => {
        setPendingVideoDraftDelete(
            null
        );
    };

const confirmVideoDraftDelete =
    async () => {
        const draft =
            pendingVideoDraftDelete;

        if (!draft?.id) {
            setPendingVideoDraftDelete(
                null
            );

            return;
        }

        try {
            setRecordingError("");

            await deleteVideoDraftFromDatabase(
                draft.id
            );

            setVideoDrafts(
                (currentDrafts) =>
                    currentDrafts.filter(
                        (currentDraft) =>
                            currentDraft.id !==
                            draft.id
                    )
            );

            if (
                activeVideoDraftId ===
                draft.id
            ) {
                setActiveVideoDraftId(
                    null
                );

                setVideoDraftSaveMessage(
                    ""
                );
            }

            setPendingVideoDraftDelete(
                null
            );
        } catch (error) {
            console.error(
                "Unable to delete video draft:",
                error
            );

            setRecordingError(
                error?.message ||
                    "Unable to delete the video draft."
            );
        }
    };
const saveRecordingDraft =
    async () => {
        if (!recordingUrl) {
            setRecordingError(
                "There is no recording available to save as a draft."
            );

            return;
        }

        try {
            setIsSavingVideoDraft(true);
            setVideoDraftSaveMessage("");
            setRecordingError("");

            const response =
                await fetch(recordingUrl);

            if (!response.ok) {
                throw new Error(
                    "The recording could not be read for draft storage."
                );
            }

            const sourceBlob =
                await response.blob();

            if (
                !sourceBlob ||
                sourceBlob.size === 0
            ) {
                throw new Error(
                    "The recording contains no video data."
                );
            }

            const timestamp =
                new Date().toISOString();

            const existingDraft =
                activeVideoDraftId
                    ? videoDrafts.find(
                        (draft) =>
                            draft.id ===
                            activeVideoDraftId
                    )
                : null;

            const draftId =
                activeVideoDraftId ||
                `video-draft-${
                    childId || "child"
                }-${Date.now()}-${Math.random()
                    .toString(36)
                    .slice(2, 8)}`;

            const cleanSegments =
                editorSegments.map(
                    (segment) => ({
                        id:
                            segment.id ||
                            `segment-${Date.now()}-${Math.random()
                                .toString(36)
                                .slice(2, 8)}`,

                        start:
                            Number(
                                segment.start
                            ) || 0,

                        end:
                            Number(
                                segment.end
                            ) || 0,

                        deleted:
                            Boolean(
                                segment.deleted
                            ),
                    })
                );

            const videoDraft = {
                id: draftId,
                draftVersion: 1,

                childId:
                    childId || null,

                scope:
                    scope || "dashboard",

                childScope: `${
                    childId ||
                    "unknown-child"
                }::${
                    scope ||
                    "dashboard"
                }`,

                workspaceMode,
                activeWorkspace,

                folderId:
                    activeFolderId ||
                    null,

                title:
                    recordingTitle.trim() ||
                    "Untitled Video Draft",

                description:
                    recordingDescription.trim(),

                recordingMode:
                    recordingMode ||
                    "screen",

                mimeType:
                    recordingMimeType ||
                    sourceBlob.type ||
                    "video/webm",

                sourceBlob,

                sourceDuration:
                    Math.max(
                        Number(
                            editorDuration
                        ) || 0,
                        Number(
                            recordingSeconds
                        ) || 0
                    ),

                segments:
                    cleanSegments,

                muteOriginalAudio:
                    Boolean(
                        editorMuteOriginalAudio
                    ),

                createdAt:
                    existingDraft?.createdAt ||
                    timestamp,

                updatedAt: timestamp,
            };

await putVideoDraftInDatabase(
    videoDraft
);

setVideoDrafts(
    (currentDrafts) =>
        [
            videoDraft,
            ...currentDrafts.filter(
                (currentDraft) =>
                    currentDraft.id !==
                    draftId
            ),
        ].sort(
            (
                firstDraft,
                secondDraft
            ) =>
                new Date(
                    secondDraft.updatedAt ||
                        0
                ).getTime() -
                new Date(
                    firstDraft.updatedAt ||
                        0
                ).getTime()
        )
);

setActiveVideoDraftId(
    draftId
);

            setVideoDraftSaveMessage(
                "Draft Saved"
            );

            setRecordingError("");
        } catch (error) {
            console.error(
                "Unable to save video draft:",
                error
            );

            setRecordingError(
                error?.message ||
                    "Unable to save the video draft."
            );
        } finally {
            setIsSavingVideoDraft(
                false
            );
        }
    };


React.useEffect(() => {
    try {
        const savedFolders = JSON.parse(
            localStorage.getItem(
                foldersStorageKey
            ) || "[]"
        );

        const validFolders =
            Array.isArray(savedFolders)
                ? savedFolders.map((folder) => ({
                    ...folder,
                    resources: Array.isArray(folder.resources)
                        ? folder.resources
                        : [],
                }))
                : [];

        setFolders(validFolders);

        setActiveFolderId(
            validFolders.length > 0
                ? validFolders[0].id
                : null
        );
    } catch (error) {
        console.error(
            "Unable to load Archivum folders:",
            error
        );

        setFolders([]);
        setActiveFolderId(null);
    }
}, [foldersStorageKey]);


const openVideoLinkPanel = () => {
    setVideoLinkTitle("");
    setVideoLinkUrl("");
    setVideoLinkDescription("");
    setVideoLinkError("");
    setVideoLinkSaveMessage("");
    setIsVideoLinkOpen(true);
};

const closeVideoLinkPanel = () => {
    setIsVideoLinkOpen(false);
    setVideoLinkError("");
};

const saveVideoLink = () => {
    const cleanTitle =
        videoLinkTitle.trim();

    const cleanUrl =
        videoLinkUrl.trim();

    const cleanDescription =
        videoLinkDescription.trim();

    if (!cleanTitle) {
        setVideoLinkError(
            "Enter a title for this video."
        );

        return;
    }

    if (!cleanUrl) {
        setVideoLinkError(
            "Paste the video link."
        );

        return;
    }

    let parsedUrl;

    try {
        parsedUrl = new URL(cleanUrl);
    } catch {
        setVideoLinkError(
            "Enter a complete video link beginning with http:// or https://."
        );

        return;
    }

    if (
        parsedUrl.protocol !== "http:" &&
        parsedUrl.protocol !== "https:"
    ) {
        setVideoLinkError(
            "Only http:// or https:// video links are supported."
        );

        return;
    }

    const timestamp =
        new Date().toISOString();

    const newVideoLink = {
        id: `video-link-${Date.now()}-${Math.random()
            .toString(36)
            .slice(2, 8)}`,

        title: cleanTitle,
        url: parsedUrl.href,
        description: cleanDescription,

        folderId:
            activeFolderId || null,

        childId:
            childId || null,

        scope:
            scope || "dashboard",

        createdAt: timestamp,
        updatedAt: timestamp,
    };

    const updatedVideoLinks = [
        newVideoLink,
        ...videoLinks,
    ];

    setVideoLinks(updatedVideoLinks);

    try {
        localStorage.setItem(
            videoLinksStorageKey,
            JSON.stringify(
                updatedVideoLinks
            )
        );

        setVideoLinkSaveMessage(
            "Video link saved to Archivum."
        );

        window.setTimeout(() => {
            setVideoLinkSaveMessage("");
        }, 4000);

    setIsVideoLinkOpen(false);
        setVideoLinkTitle("");
        setVideoLinkUrl("");
        setVideoLinkDescription("");
        setVideoLinkError("");
    } catch (error) {
        console.error(
            "Unable to save video link:",
            error
        );

        setVideoLinkError(
            "The video link could not be saved."
        );
    }
};

const createFolder = () => {
    const cleanName =
        newFolderName.trim();

    if (!cleanName) {
        return;
    }

    const newFolder = {
        id: `${Date.now()}-${Math.random()
            .toString(36)
            .slice(2, 8)}`,
        name: cleanName,
        description:
            newFolderDescription.trim(),
        resources: [],
        createdAt:
            new Date().toISOString(),
        updatedAt:
            new Date().toISOString(),
    };


    const updatedFolders = [
        ...folders,
        newFolder,
    ];

    setFolders(updatedFolders);
    setActiveFolderId(newFolder.id);
    setNewFolderName("");
    setNewFolderDescription("");

    try {
        localStorage.setItem(
            foldersStorageKey,
            JSON.stringify(updatedFolders)
        );
    } catch (error) {
        console.error(
            "Unable to save Archivum folder:",
            error
        );
    }
};

const saveResourceToFolder = ({
    folderId,
    resource,
}) => {
    if (!folderId || !resource) {
        return false;
    }

    const timestamp =
        new Date().toISOString();

    const updatedFolders =
        folders.map((folder) =>
            folder.id === folderId
                ? {
                      ...folder,
                      resources: [
                          {
                              ...resource,
                              id:
                                  resource.id ||
                                  `${Date.now()}-${Math.random()
                                      .toString(36)
                                      .slice(2, 8)}`,
                              createdAt:
                                  resource.createdAt ||
                                  timestamp,
                              updatedAt:
                                  timestamp,
                          },
                          ...(Array.isArray(
                              folder.resources
                          )
                              ? folder.resources
                              : []),
                      ],
                      updatedAt:
                          timestamp,
                  }
                : folder
        );

    setFolders(updatedFolders);

    try {
        localStorage.setItem(
            foldersStorageKey,
            JSON.stringify(updatedFolders)
        );

        return true;
    } catch (error) {
        console.error(
            "Unable to save classroom resource:",
            error
        );

        return false;
    }
};
const startEditingFolder = (folder) => {
    setEditingFolderId(folder.id);
    setEditingFolderName(
        folder.name || ""
    );
    setEditingFolderDescription(
        folder.description || ""
    );
};

const cancelEditingFolder = () => {
    setEditingFolderId(null);
    setEditingFolderName("");
    setEditingFolderDescription("");
};

const saveEditedFolder = () => {
    const cleanName =
        editingFolderName.trim();

    if (!cleanName || !editingFolderId) {
        return;
    }

    const updatedFolders = folders.map(
        (folder) =>
            folder.id === editingFolderId
                ? {
                      ...folder,
                      name: cleanName,
                      description:
                          editingFolderDescription.trim(),
                      updatedAt:
                          new Date().toISOString(),
                  }
                : folder
    );

    setFolders(updatedFolders);

    try {
        localStorage.setItem(
            foldersStorageKey,
            JSON.stringify(updatedFolders)
        );
    } catch (error) {
        console.error(
            "Unable to update Archivum folder:",
            error
        );
    }

    cancelEditingFolder();
};

const deleteFolder = (folderId) => {
    const folderToDelete = folders.find(
        (folder) =>
            folder.id === folderId
    );

    const shouldDelete = window.confirm(
        `Delete "${
            folderToDelete?.name ||
            "this folder"
        }"?`
    );

    if (!shouldDelete) {
        return;
    }

    const updatedFolders = folders.filter(
        (folder) =>
            folder.id !== folderId
    );

    setFolders(updatedFolders);

    if (activeFolderId === folderId) {
        setActiveFolderId(
            updatedFolders.length > 0
                ? updatedFolders[0].id
                : null
        );
    }

    if (editingFolderId === folderId) {
        cancelEditingFolder();
    }

    try {
        localStorage.setItem(
            foldersStorageKey,
            JSON.stringify(updatedFolders)
        );
    } catch (error) {
        console.error(
            "Unable to delete Archivum folder:",
            error
        );
    }
};

const handleNotesChange = (
    nextNotes
) => {
    setNotes(nextNotes);

    if (workspaceMode === "private") {
        try {
            localStorage.setItem(
                storageKey,
                nextNotes
            );
        } catch (error) {
            console.error(
                "Unable to save private notes:",
                error
            );
        }

        return;
    }

    const nextWorkspace = {
        ...(sharedWorkspace || {}),
        title:
            sharedWorkspace?.title ||
            title ||
            "Shared Workspace",
        workspace_type: "notepad",
        scope,
        folder_id:
            activeFolderId ||
            sharedWorkspace?.folder_id ||
            null,
        quest_id:
            sharedWorkspace?.quest_id ||
            null,
        participant_mode:
            sharedWorkspace?.participant_mode ||
            "selected",
        participant_child_ids:
            sharedWorkspace
                ?.participant_child_ids
                ?.length > 0
                ? sharedWorkspace
                      .participant_child_ids
                : [childId],
        child_access:
            sharedWorkspace?.child_access ||
            "edit",
        notepad_html: nextNotes,
        tabula_data:
            sharedWorkspace?.tabula_data ||
            {},
        slides:
            sharedWorkspace?.slides ||
            [],
        active_slide_id:
            sharedWorkspace
                ?.active_slide_id ||
            null,
        recording_resource_ids:
            sharedWorkspace
                ?.recording_resource_ids ||
            [],
    };

    sharedBusyRef.current = true;
    const epoch = ++sharedEpochRef.current;
    setSharedWorkspace(nextWorkspace);
    setSharedStatus("saving");
    setSharedError("");

    if (sharedSaveTimerRef.current) {
        window.clearTimeout(
            sharedSaveTimerRef.current
        );
    }

    sharedSaveTimerRef.current =
        window.setTimeout(async () => {
            try {
                const savedWorkspace =
                    await saveLiveWorkspace({
                        childId,
                        scope,
                        workspaceType:
                            "notepad",
                        workspace:
                            nextWorkspace,
                    });

                if (epoch !== sharedEpochRef.current) return;
                sharedBusyRef.current = false;
                sharedSnapshotRef.current = JSON.stringify(savedWorkspace);
                setSharedWorkspace(
                    savedWorkspace
                );
                setSharedStatus("saved");
            } catch (error) {
                if (epoch !== sharedEpochRef.current) return;
                console.error(
                    "Unable to save shared notes:",
                    error
                );

                setSharedError(
                    error.response?.data
                        ?.detail ||
                        "Unable to save shared notes."
                );

                sharedBusyRef.current = false;
                setSharedStatus("error");
            }
        }, 350);
};
const handleSharedTabulaChange =
    async (nextTabulaData) => {
        const nextWorkspace = {
            ...(sharedWorkspace || {}),
            title:
                sharedWorkspace?.title ||
                `${title} · Tabula`,
            workspace_type: "tabula",
            scope,
            folder_id:
                activeFolderId ||
                sharedWorkspace?.folder_id ||
                null,
            quest_id:
                sharedWorkspace?.quest_id ||
                null,
            participant_mode:
                sharedWorkspace
                    ?.participant_mode ||
                "selected",
            participant_child_ids:
                sharedWorkspace
                    ?.participant_child_ids
                    ?.length > 0
                    ? sharedWorkspace
                          .participant_child_ids
                    : [childId],
            child_access:
                sharedWorkspace
                    ?.child_access ||
                "edit",
            notepad_html:
                sharedWorkspace
                    ?.notepad_html ||
                "",
            tabula_data:
                nextTabulaData,
            slides:
                sharedWorkspace?.slides ||
                [],
            active_slide_id:
                sharedWorkspace
                    ?.active_slide_id ||
                null,
            recording_resource_ids:
                sharedWorkspace
                    ?.recording_resource_ids ||
                [],
        };

        sharedBusyRef.current = true;
        const epoch = ++sharedEpochRef.current;
        setSharedWorkspace(
            nextWorkspace
        );
        setSharedStatus("saving");
        setSharedError("");

        try {
            const savedWorkspace =
                await saveLiveWorkspace({
                    childId,
                    scope,
                    workspaceType:
                        "tabula",
                    workspace:
                        nextWorkspace,
                });

            if (epoch !== sharedEpochRef.current) return savedWorkspace;
            sharedBusyRef.current = false;
            sharedSnapshotRef.current = JSON.stringify(savedWorkspace);
            setSharedWorkspace(
                savedWorkspace
            );
            setSharedStatus("saved");

            return savedWorkspace;
        } catch (error) {
            if (epoch !== sharedEpochRef.current) throw error;
            console.error(
                "Unable to save shared Tabula:",
                error
            );

            const errorMessage =
                error.response?.data
                    ?.detail ||
                "Unable to save shared Tabula.";

            setSharedError(
                errorMessage
            );
            setSharedStatus("error");

            sharedBusyRef.current = false;
            throw error;
        }
    };

const changeLiveAudience = async (participantMode) => {
    sharedBusyRef.current = true;
    sharedEpochRef.current += 1;
    setSharedStatus("saving");
    try {
        const saved = await saveLiveWorkspace({childId, scope, workspaceType: activeWorkspace === "whiteboard" ? "tabula" : "notepad", workspace: {...sharedWorkspace, participant_mode: participantMode}});
        sharedSnapshotRef.current = JSON.stringify(saved);
        setSharedWorkspace(saved);
        setSharedStatus("saved");
    } catch (error) {
        setSharedError("Unable to change live sharing. Please try again.");
        setSharedStatus("error");
    } finally { sharedBusyRef.current = false; }
};
if (!isOpen) {
    return (
        <button
            type="button"
            onClick={() => setPanelOpen(true)}
            aria-label="Open Notes and Tabula"
            title="Open Notes and Tabula"
            className="
            fixed
            right-0
            top-1/2
            z-[120]
            flex
            -translate-y-1/2
            flex-col
            items-center
            gap-2
            rounded-l-2xl
            border
            border-r-0
            border-[#c084fc]/70
            bg-[#2b1548]
            px-2.5
            py-4
            text-[#f3e8ff]
            shadow-[0_0_24px_rgba(168,85,247,0.35)]
            transition-all
            duration-200
            hover:border-[#ffd166]
            hover:bg-[#3b1d63]
            hover:text-[#ffd166]
            hover:shadow-[0_0_30px_rgba(192,132,252,0.50)]
        "
        >
            <NotebookPen size={18} />

            <span
                className="
                    rotate-180
                    text-[11px]
                    font-semibold
                    uppercase
                    tracking-[0.18em]
                    [writing-mode:vertical-rl]
                "
            >
                Notes & Tabula
            </span>
        </button>
    );
}
    return (
<aside
    ref={workspacePanelRef}
    className={`
        flex
        min-h-0
        flex-col
        overflow-hidden
        border
        border-[#ffd166]/40
        bg-black
        shadow-[0_0_30px_rgba(255,209,102,0.10)]
        ${
            isExpanded
                ? "fixed inset-0 z-[100] h-dvh w-screen rounded-none"
                : "h-[calc(100dvh-1rem)] min-h-[480px] max-h-none resize-y rounded-[32px] md:self-start"
        }
        `}
    style={
        !isExpanded && customPanelHeight
            ? {
                  height: `${customPanelHeight}px`,
              }
            : undefined
    }
>
            <div className="flex shrink-0 items-center justify-between gap-2 border-b border-[#ffd166]/20 px-3 py-2">
            <div
                className={
                    isExpanded &&
                    areTopControlsHidden
                        ? "hidden"
                        : "flex items-center gap-3"
                }
            >
                    <div className="flex h-8 w-8 items-center justify-center rounded-lg border border-[#ffd166]/35 bg-[#2b1548]/65 text-[#ffd166]">
                        <NotebookPen size={16} />
                    </div>

                    <div>
                        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#d8b4fe]">
                            Notes
                        </p>

                        <h2 className="font-display text-lg text-[#ffd166]">
                            {title}
                        </h2>
                    </div>
                </div>

<div className="flex items-center gap-2">
{isExpanded && (
    <button
        type="button"
        onClick={() =>
            setAreTopControlsHidden(
                (currentValue) =>
                    !currentValue
            )
        }
        title={
            areTopControlsHidden
                ? "Show workspace controls"
                : "Hide workspace controls"
        }
        className="
            inline-flex
            h-7
            items-center
            justify-center
            rounded-lg
            border
            border-[#ffd166]/30
            bg-[#080b14]
            px-2
            text-[10px]
            font-semibold
            text-[#fff3c4]
            transition
            hover:border-[#ffd166]
            hover:text-[#ffd166]
        "
    >
        {areTopControlsHidden
            ? "Show Controls"
            : "Hide Controls"}
    </button>
)}
    {!isExpanded && (
        <div className="flex items-center gap-1">
            <button
                type="button"
                onClick={() =>
                    setCustomPanelHeight(
                        (currentHeight) =>
                            Math.max(
                                480,
                                (currentHeight ||
                                    window.innerHeight -
                                        16) -
                                    240
                            )
                    )
                }
                title="Make workspace shorter"
                aria-label="Make workspace shorter"
                className="
                    inline-flex
                    h-7
                    min-w-7
                    items-center
                    justify-center
                    rounded-lg
                    border
                    border-[#ffd166]/30
                    bg-[#080b14]
                    px-1.5
                    text-sm
                    font-semibold
                    text-[#fff3c4]
                    hover:border-[#ffd166]
                    hover:text-[#ffd166]
                "
            >
                −
            </button>

            <button
                type="button"
                onClick={() =>
                    setCustomPanelHeight(
                        (currentHeight) =>
                            (currentHeight ||
                                window.innerHeight -
                                    16) + 240
                    )
                }
                title="Extend workspace farther down"
                aria-label="Make workspace taller"
                className="
                    inline-flex
                    h-7
                    min-w-7
                    items-center
                    justify-center
                    rounded-lg
                    border
                    border-[#ffd166]/30
                    bg-[#2b1548]/70
                    px-1.5
                    text-sm
                    font-semibold
                    text-[#ffd166]
                    hover:border-[#ffd166]
                "
            >
                +
            </button>

            <button
                type="button"
                onClick={() =>
                    setCustomPanelHeight(null)
                }
                title="Reset workspace height"
                className="
                    inline-flex
                    h-7
                    items-center
                    justify-center
                    rounded-lg
                    border
                    border-[#ffd166]/25
                    bg-[#080b14]
                    px-2
                    text-[9px]
                    font-semibold
                    uppercase
                    text-[#b0b8d6]
                    hover:border-[#ffd166]
                    hover:text-[#ffd166]
                "
            >
                Reset
            </button>
        </div>
    )}
    <button
        type="button"
        onClick={() =>
            setIsExpanded(
                (currentValue) =>
                    !currentValue
            )
        }
        aria-label={
            isExpanded
                ? "Exit full screen"
                : "Expand workspace"
        }
        title={
            isExpanded
                ? "Exit Full Screen"
                : "Expand Workspace"
        }
        className="
            inline-flex
            h-8
            w-8
            items-center
            justify-center
            rounded-xl
            border
            border-[#ffd166]/30
            bg-[#2b1548]/60
            text-[#fff3c4]
            transition
            hover:border-[#ffd166]
            hover:text-[#ffd166]
        "
    >
        {isExpanded ? (
            <Minimize2 size={19} />
        ) : (
            <Maximize2 size={19} />
        )}
    </button>

<button
    type="button"
    onClick={() => {
        setAreTopControlsHidden(false);
        setIsExpanded(false);
        setPanelOpen(false);

        window.requestAnimationFrame(
            () => {
                document.body.style.removeProperty(
                    "overflow"
                );

                document.documentElement.style.removeProperty(
                    "overflow"
                );
            }
        );
    }}
    aria-label="Close notes panel"
        className="
            inline-flex
            h-8
            w-8
            items-center
            justify-center
            rounded-xl
            border
            border-[#ffd166]/30
            bg-[#2b1548]/60
            text-[#fff3c4]
            transition
            hover:border-[#ffd166]
            hover:text-[#ffd166]
        "
    >
            <ChevronRight size={19} />
    </button>
</div>
</div>

<div className="flex min-h-0 flex-1 flex-col">
<div
    className={`
        shrink-0
        flex-wrap
        items-center
        gap-1.5
        border-b
        border-[#ffd166]/20
        bg-black/80
        px-2
        py-1.5
        ${
            isExpanded &&
            areTopControlsHidden
                ? "hidden"
                : "flex"
        }
    `}
>
    <select
        value={activeFolderId || ""}
        onChange={(event) =>
            setActiveFolderId(
                event.target.value || null
            )
        }
        className="
            min-w-0
            flex-1
            rounded-xl
            border
            border-[#ffd166]/30
            bg-black
            px-3
            py-1.5
            text-xs
            text-[#fff3c4]
            outline-none
            focus:border-[#ffd166]
        "
    >
        <option value="">
            Choose a folder
        </option>

        {folders.map((folder) => (
            <option
                key={folder.id}
                value={folder.id}
            >
                {folder.name}
            </option>
        ))}
    </select>

    <button
        type="button"
        disabled={!activeFolderId}
        onClick={() => {
            localStorage.setItem(
                storageKey,
                notes
            );
        }}
        className="
            shrink-0
            rounded-xl
            border
            border-[#ffd166]/45
            bg-[#2b1548]/70
            px-3
            py-2
            text-xs
            font-semibold
            text-[#ffd166]
            transition
            hover:border-[#ffd166]
            hover:bg-[#3a1d60]
            disabled:cursor-not-allowed
            disabled:opacity-40
        "
        >
        Save
    </button>
<button
    type="button"
    disabled={!activeFolderId}
    onClick={() => {
        if (!activeFolderId) {
            return;
        }

        const activeFolder =
            folders.find(
                (folder) =>
                    folder.id ===
                    activeFolderId
            );

        const saved =
            saveResourceToFolder({
                folderId:
                    activeFolderId,

                resource: {
                    type: "notebook",
                    openTarget:
                        "notebook",

                    title:
                        `${
                            activeFolder?.name ||
                            "Notebook"
                        } Notes`,

                    folderId:
                        activeFolderId,

                    sourceKey:
                        storageKey,

                    snapshotHtml:
                        notes,

                    childId:
                        childId || null,

                    scope:
                        scope ||
                        "dashboard",
                },
            });

        if (saved) {
            localStorage.setItem(
                storageKey,
                notes
            );
        }
    }}
    className="
        shrink-0
        rounded-xl
        border
        border-[#c084fc]/45
        bg-[#2b1548]/70
        px-3
        py-2
        text-xs
        font-semibold
        text-[#f3e8ff]
        transition
        hover:border-[#ffd166]
        hover:text-[#ffd166]
        hover:shadow-[0_0_16px_rgba(192,132,252,0.24)]
    "
>
    Save to Resources
</button>   
</div>

<div
    className={`
        shrink-0
        flex-wrap
        items-center
        gap-1.5
        border-b
        border-[#ffd166]/20
        bg-black/80
        px-2
        py-1.5
        ${
            isExpanded &&
            areTopControlsHidden
                ? "hidden"
                : "flex"
        }
    `}
>
    <button
        type="button"
        onClick={() =>
            setWorkspaceMode("private")
        }
        className={`
            rounded-lg
            border
            px-2.5
            py-1.5
            text-[11px]
            font-semibold
            transition
            ${
                workspaceMode === "private"
                    ? "border-[#d8b4fe] bg-[#2b1548]/80 text-[#f1ddff]"
                    : "border-[#d8b4fe]/25 bg-[#080b14] text-[#b0b8d6] hover:border-[#d8b4fe]/60"
            }
        `}
    >
        Private
    </button>

    <button
    type="button"
    onClick={() =>
        setWorkspaceMode("shared")
    }
    title="Open the shared parent-and-child workspace"
    className={`
        rounded-lg
        border
        px-2.5
        py-1.5
        text-[11px]
        font-semibold
        transition
        ${
            workspaceMode === "shared"
                ? "border-[#7cc1ff] bg-[#17324d]/80 text-[#bfe3ff]"
                : "border-[#7cc1ff]/30 bg-[#080b14] text-[#9dcff5] hover:border-[#7cc1ff]/70"
        }
    `}
>
    Shared
</button>

    <div className="mx-0.5 h-6 w-px bg-[#ffd166]/20" />

    <button
        type="button"
        onClick={() =>
            setActiveWorkspace("notepad")
        }
        className={`
            inline-flex
            items-center
            justify-center
            gap-1.5
            rounded-lg
            border
            px-2.5
            py-1.5
            text-[11px]
            font-semibold
            transition
            ${
                activeWorkspace === "notepad"
                    ? "border-[#ffd166] bg-[#ffd166]/15 text-[#ffd166]"
                    : "border-[#ffd166]/25 bg-[#080b14] text-[#fff3c4] hover:border-[#ffd166]/65"
            }
        `}
    >
        <NotebookPen size={14} />
        Notepad
    </button>

    <button
        type="button"
        onClick={() =>
            setActiveWorkspace("whiteboard")
        }
        className={`
            inline-flex
            items-center
            justify-center
            gap-1.5
            rounded-lg
            border
            px-2.5
            py-1.5
            text-[11px]
            font-semibold
            transition
            ${
                activeWorkspace === "whiteboard"
                    ? "border-[#ffd166] bg-[#ffd166]/15 text-[#ffd166]"
                    : "border-[#ffd166]/25 bg-[#080b14] text-[#fff3c4] hover:border-[#ffd166]/65"
            }
        `}
        >
             <PencilRuler size={14} />
            Tabula
        </button>

        <button
            type="button"
            onClick={() =>
                setActiveWorkspace("resources")
            }
            className={`
                inline-flex
                items-center
                justify-center
                gap-1.5
                rounded-lg
                border
                px-2.5
                py-1.5
                text-[11px]
                font-semibold
                transition
                ${
                    activeWorkspace === "resources"
                        ? "border-[#ffd166] bg-[#ffd166]/15 text-[#ffd166]"
                        : "border-[#ffd166]/25 bg-[#080b14] text-[#fff3c4] hover:border-[#ffd166]/65"
                }
            `}
        >
            <FolderOpen size={14} />
            Resources
        </button>

    </div>

{recordingError && (
    <div
        className="
            shrink-0
            border-b
            border-red-400/25
            bg-red-950/35
            px-3
            py-1.5
            text-[11px]
            text-red-200
        "
    >
        {recordingError}
    </div>
)}

{pendingVideoDraftDelete && (
    <div
        className="
            fixed
            inset-0
            z-[310]
            flex
            items-center
            justify-center
            bg-black/90
            p-4
        "
    >
        <div
            className="
                w-full
                max-w-md
                rounded-[28px]
                border
                border-[#ffd166]/40
                bg-[#05070d]
                p-5
                shadow-[0_0_40px_rgba(255,209,102,0.16)]
            "
        >
            <p
                className="
                    text-[10px]
                    font-semibold
                    uppercase
                    tracking-[0.2em]
                    text-[#d8b4fe]
                "
            >
                Draft Videos
            </p>

            <h3
                className="
                    mt-2
                    font-display
                    text-2xl
                    text-[#ffd166]
                "
            >
                Delete Video Draft?
            </h3>

            <p
                className="
                    mt-3
                    text-sm
                    leading-relaxed
                    text-[#c8cee4]
                "
            >
                This will permanently remove
                <span className="font-semibold text-[#fff3c4]">
                    {" "}
                    “
                    {pendingVideoDraftDelete.title ||
                        "Untitled Video Draft"}
                    ”
                </span>
                {" "}from this browser.
            </p>

            <p className="mt-2 text-xs text-[#8f9abd]">
                The deleted draft cannot be restored.
            </p>

            <div
                className="
                    mt-5
                    flex
                    items-center
                    justify-end
                    gap-3
                    border-t
                    border-[#ffd166]/15
                    pt-4
                "
            >
                <button
                    type="button"
                    onClick={
                        cancelVideoDraftDelete
                    }
                    className="
                        border-0
                        bg-transparent
                        px-3
                        py-2
                        text-sm
                        font-semibold
                        text-[#d8b4fe]
                        transition
                        hover:text-[#f1ddff]
                    "
                >
                    Keep Draft
                </button>

                <button
                    type="button"
                    onClick={() => {
                        void confirmVideoDraftDelete();
                    }}
                    className="
                        rounded-xl
                        border
                        border-red-400/35
                        bg-red-950/35
                        px-4
                        py-2
                        text-sm
                        font-semibold
                        text-red-200
                        transition
                        hover:border-red-300
                        hover:text-white
                    "
                >
                    Delete Draft
                </button>
            </div>
        </div>
    </div>
)}

{isRecordingReviewOpen &&
recordingUrl &&
!isRecording && (
    <div
        className="
            fixed
            inset-0
            z-[250]
            flex
            items-center
            justify-center
            overflow-y-auto
            bg-black/90
            p-4
        "
    >
        <div
            className="
                my-auto
                w-full
                max-w-3xl
                rounded-[30px]
                border
                border-[#ffd166]/45
                bg-[#05070d]
                p-5
                shadow-[0_0_45px_rgba(255,209,102,0.18)]
            "
        >
            <div className="mb-4 border-b border-[#ffd166]/20 pb-3">
                <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#d8b4fe]">
                    Recording Complete
                </p>

                <h3 className="mt-1 font-display text-2xl text-[#ffd166]">
                    Review Your Recording
                </h3>

                <p className="mt-1 text-xs text-[#b0b8d6]">
                    Review the video before saving or deleting it.
                </p>
            </div>

            <div
                className="
                    overflow-hidden
                    rounded-2xl
                    border
                    border-[#ffd166]/20
                    bg-black
                "
            >
                {recordingMode ===
                "screen" ? (
                    <video
                    key={`review-${recordingUrl}`}
                    src={recordingUrl}
                    controls
                    preload="metadata"
                    onLoadedData={
                        resetRecordingPlayerToStart
                    }
                        className="
                            max-h-[58vh]
                            w-full
                            bg-black
                        "
                    />
                ) : (
                    <audio
                        src={recordingUrl}
                        controls
                        className="w-full"
                    />
                )}
            </div>

            <div
                className="
                    mt-4
                    grid
                    grid-cols-2
                    gap-2
                    sm:grid-cols-4
                "
            >
                <button
                    type="button"
                    onClick={downloadRecording}
                    className="
                        rounded-xl
                        border
                        border-[#ffd166]/40
                        bg-[#2b1548]/75
                        px-3
                        py-2
                        text-xs
                        font-semibold
                        text-[#fff3c4]
                        transition
                        hover:border-[#ffd166]
                        hover:text-[#ffd166]
                        hover:shadow-[0_0_14px_rgba(216,180,254,0.45)]
                    "
                >
                    Save to Computer
                </button>

<button
    type="button"
    onClick={openRecordingEditor}
    className="
        rounded-xl
        border
        border-[#d8b4fe]/40
        bg-[#2b1548]/70
        px-3
        py-2
        text-xs
        font-semibold
        text-[#f1ddff]
        transition
        hover:border-[#d8b4fe]
        hover:text-white
        hover:shadow-[0_0_14px_rgba(216,180,254,0.55)]
    "
>
    Edit / Cut
</button>

                <button
                    type="button"
                    disabled
                    title="Folder saving will be connected next."
                    className="
                        rounded-xl
                        border
                        border-[#ffd166]/25
                        bg-[#2b2412]/35
                        px-3
                        py-2
                        text-xs
                        font-semibold
                        text-[#ffd166]/55
                        opacity-70
                    "
                >
                    Send to Folder
                </button>

                <button
                    type="button"
                    onClick={deleteRecording}
                    className="
                        rounded-xl
                        border
                        border-red-400/35
                        bg-red-950/45
                        px-3
                        py-2
                        text-xs
                        font-semibold
                        text-red-200
                        transition
                        hover:border-red-300
                        hover:text-red-100
                    "
                >
                    Delete
                </button>
            </div>

            <button
                type="button"
                onClick={() =>
                    setIsRecordingReviewOpen(
                        false
                    )
                }
                className="
                    mt-3
                    w-full
                    rounded-xl
                    border
                    border-[#ffd166]/20
                    bg-black
                    px-3
                    py-2
                    text-xs
                    font-semibold
                    text-[#b0b8d6]
                    transition
                    hover:border-[#ffd166]/60
                    hover:text-[#ffd166]
                "
            >
                Close for Now
            </button>
        </div>
    </div>
)}

{isVideoDraftsOpen && (
    <div
        className="
            fixed
            inset-0
            z-[275]
            flex
            items-center
            justify-center
            overflow-y-auto
            bg-black/90
            p-4
        "
    >
        <div
            className="
                my-auto
                w-full
                max-w-4xl
                rounded-[30px]
                border
                border-[#d8b4fe]/45
                bg-[#05070d]
                p-5
                shadow-[0_0_45px_rgba(216,180,254,0.18)]
            "
        >
            <div
                className="
                    flex
                    flex-wrap
                    items-start
                    justify-between
                    gap-3
                    border-b
                    border-[#ffd166]/20
                    pb-3
                "
            >
                <div>
                    <p
                        className="
                            text-[10px]
                            font-semibold
                            uppercase
                            tracking-[0.2em]
                            text-[#d8b4fe]
                        "
                    >
                        Saved Work
                    </p>

                    <h3
                        className="
                            mt-1
                            font-display
                            text-2xl
                            text-[#ffd166]
                        "
                    >
                        Draft Videos
                    </h3>

                    <p className="mt-1 text-xs text-[#b0b8d6]">
                        Continue recordings saved from
                        Notepad or Tabula.
                    </p>
                </div>

                <button
                    type="button"
                    onClick={
                        closeVideoDraftsPanel
                    }
                    className="
                        border-0
                        bg-transparent
                        px-2
                        py-1
                        text-sm
                        font-semibold
                        text-[#d8b4fe]
                        transition
                        hover:text-[#ffd166]
                    "
                >
                    Close
                </button>
            </div>

            {isLoadingVideoDrafts ? (
                <div
                    className="
                        flex
                        min-h-[220px]
                        items-center
                        justify-center
                        text-sm
                        text-[#d8b4fe]
                    "
                >
                    Loading video drafts...
                </div>
            ) : videoDrafts.length > 0 ? (
                <div
                    className="
                        mt-4
                        grid
                        grid-cols-1
                        gap-3
                        md:grid-cols-2
                    "
                >
                    {videoDrafts.map(
                        (draft) => (
                            <div
                                key={draft.id}
                                className="
                                    rounded-2xl
                                    border
                                    border-[#ffd166]/20
                                    bg-black/45
                                    p-4
                                "
                            >
                                <div
                                    className="
                                        flex
                                        items-start
                                        justify-between
                                        gap-3
                                    "
                                >
                                    <div className="min-w-0">
                                        <h4
                                            className="
                                                truncate
                                                text-sm
                                                font-semibold
                                                text-[#ffd166]
                                            "
                                        >
                                            {draft.title ||
                                                "Untitled Video Draft"}
                                        </h4>

                                        <p
                                            className="
                                                mt-1
                                                line-clamp-2
                                                text-xs
                                                leading-relaxed
                                                text-[#b0b8d6]
                                            "
                                        >
                                            {draft.description ||
                                                "No description added."}
                                        </p>
                                    </div>

                                    <Play
                                        size={18}
                                        className="
                                            shrink-0
                                            text-[#d8b4fe]
                                        "
                                    />
                                </div>

                                <div
                                    className="
                                        mt-3
                                        flex
                                        flex-wrap
                                        gap-x-4
                                        gap-y-1
                                        text-[10px]
                                        text-[#8f9abd]
                                    "
                                >
                                    <span>
                                        Duration:{" "}
                                        {formatRecordingTime(
                                            draft.sourceDuration ||
                                                0
                                        )}
                                    </span>

                                    <span>
                                        Sections:{" "}
                                        {Array.isArray(
                                            draft.segments
                                        )
                                            ? draft.segments.filter(
                                                  (
                                                      segment
                                                  ) =>
                                                      !segment.deleted
                                              ).length
                                            : 0}
                                    </span>
                                </div>

                                <p
                                    className="
                                        mt-2
                                        text-[10px]
                                        text-[#6f7b9c]
                                    "
                                >
                                    Last saved:{" "}
                                    {draft.updatedAt
                                        ? new Date(
                                              draft.updatedAt
                                          ).toLocaleString()
                                        : "Unknown"}
                                </p>

                                <div
                                    className="
                                        mt-3
                                        flex
                                        flex-wrap
                                        gap-2
                                        border-t
                                        border-[#ffd166]/10
                                        pt-3
                                    "
                                >
                                    <button
                                        type="button"
                                        onClick={() => {
                                            continueEditingVideoDraft(
                                                draft
                                            );
                                        }}
                                        className="
                                            border-0
                                            bg-transparent
                                            px-2
                                            py-1
                                            text-xs
                                            font-semibold
                                            text-[#d8b4fe]
                                            transition
                                            hover:text-[#f1ddff]
                                        "
                                    >
                                        Continue Editing
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            downloadVideoDraftOriginal(
                                                draft
                                            );
                                        }}
                                        className="
                                            border-0
                                            bg-transparent
                                            px-2
                                            py-1
                                            text-xs
                                            font-semibold
                                            text-[#ffd166]
                                            transition
                                            hover:text-[#ffe69a]
                                        "
                                    >
                                            Download Original
                                    </button>

                                   <button
                                        type="button"
                                        onClick={() => {
                                            void deleteSavedVideoDraft(
                                                draft
                                            );
                                        }}
                                        className="
                                            ml-auto
                                            border-0
                                            bg-transparent
                                            px-2
                                            py-1
                                            text-xs
                                            font-semibold
                                            text-red-300
                                            transition
                                            hover:text-red-200
                                        "
                                    >
                                        Delete
                                    </button>
                                </div>
                            </div>
                        )
                    )}
                </div>
            ) : (
                <div
                    className="
                        mt-4
                        rounded-2xl
                        border
                        border-[#ffd166]/15
                        bg-black/40
                        px-4
                        py-12
                        text-center
                    "
                >
                    <p className="text-sm font-semibold text-[#ffd166]">
                        No video drafts yet
                    </p>

                    <p className="mt-1 text-xs text-[#b0b8d6]">
                        Open a recording in the editor
                        and choose Save Video Draft.
                    </p>
                </div>
            )}
        </div>
    </div>
)}

{isRecordingEditorOpen &&
recordingUrl &&
!isRecording && (
    <div
        className="
            fixed
            inset-0
            z-[300]
            flex
            items-center
            justify-center
            overflow-y-auto
            bg-black/95
            p-4
        "
    >
        <div
            className="
                my-auto
                w-full
                max-w-4xl
                rounded-[30px]
                border
                border-[#d8b4fe]/45
                bg-[#05070d]
                p-5
                shadow-[0_0_50px_rgba(216,180,254,0.20)]
            "
        >
<div
    className="
        flex
        items-start
        justify-between
        gap-4
        border-b
        border-[#ffd166]/20
        pb-3
    "
>
    <div>
        <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#d8b4fe]">
            Recording Editor
        </p>

        <h3 className="mt-1 font-display text-2xl text-[#ffd166]">
            Edit Your Recording
        </h3>

        <p className="mt-1 text-xs text-[#b0b8d6]">
            Edit the video, divide it into
            sections, and prepare it for
            saving.
        </p>
    </div>

    <button
        type="button"
        onClick={closeRecordingEditor}
        title="Close recording editor"
        aria-label="Close recording editor"
        className="
            shrink-0
            border-0
            bg-transparent
            px-2
            py-1
            text-sm
            font-semibold
            text-[#d8b4fe]
            transition
            hover:text-[#ffd166]
        "
    >
        Close
    </button>
</div>

            <div
                className="
                    mt-4
                    grid
                    grid-cols-1
                    gap-3
                    rounded-2xl
                    border
                    border-[#ffd166]/15
                    bg-[#080b14]
                    p-4
                    md:grid-cols-2
                "
            >
                <label className="text-xs text-[#b0b8d6]">
                    <span className="mb-1 block font-semibold text-[#ffd166]">
                        Recording Title
                    </span>

                    <input
                        type="text"
                        value={recordingTitle}
                        onChange={(event) =>
                            setRecordingTitle(
                                event.target.value
                            )
                        }
                        maxLength={120}
                        placeholder="Name this recording..."
                        className="
                            w-full
                            rounded-xl
                            border
                            border-[#ffd166]/30
                            bg-black
                            px-3
                            py-2
                            text-xs
                            text-[#fff3c4]
                            outline-none
                            placeholder:text-[#6c7a9c]
                            focus:border-[#ffd166]
                            focus:shadow-[0_0_14px_rgba(255,209,102,0.14)]
                        "
                    />
                </label>

                <label className="text-xs text-[#b0b8d6]">
                    <span className="mb-1 block font-semibold text-[#ffd166]">
                        Description
                    </span>

                    <textarea
                        value={
                            recordingDescription
                        }
                        onChange={(event) =>
                            setRecordingDescription(
                                event.target.value
                            )
                        }
                        maxLength={500}
                        rows={3}
                        placeholder="Describe the lesson or recording..."
                        className="
                            w-full
                            resize-y
                            rounded-xl
                            border
                            border-[#d8b4fe]/30
                            bg-black
                            px-3
                            py-2
                            text-xs
                            leading-relaxed
                            text-[#fff3c4]
                            outline-none
                            placeholder:text-[#6c7a9c]
                            focus:border-[#d8b4fe]
                            focus:shadow-[0_0_14px_rgba(216,180,254,0.18)]
                        "
                    />
                </label>
            </div>

            <div
                className="
                    mt-4
                    overflow-hidden
                    rounded-2xl
                    border
                    border-[#ffd166]/20
                    bg-black
                "
            >
                <video
                    ref={
                        recordingEditorVideoRef
                    }
                    key={`editor-${recordingUrl}`}
                    src={recordingUrl}
                    controls
                    preload="metadata"
                    onLoadedData={
                        resetRecordingPlayerToStart
                    }
                    muted={
                        editorMuteOriginalAudio
                    }
                    onLoadedMetadata={
                        handleRecordingEditorLoaded
                    }
                    onTimeUpdate={
                        handleRecordingEditorTimeUpdate
                    }
                    className="
                        max-h-[52vh]
                        w-full
                        bg-black
                    "
                />
            </div>
        <div
    className="
        mt-4
        rounded-2xl
        border
        border-[#ffd166]/15
        bg-[#080b14]
        p-4
    "
>
    <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
            <p className="text-xs font-semibold text-[#ffd166]">
                Video Timeline
            </p>

            <p className="mt-1 text-[10px] text-[#b0b8d6]">
                Click a video slide or move the
                playhead, then split the recording
                into sections.
            </p>
        </div>

        <div className="text-right">
            <p className="text-[10px] uppercase tracking-[0.15em] text-[#d8b4fe]">
                Playhead
            </p>

            <p className="text-sm font-semibold tabular-nums text-[#ffd166]">
                {formatEditorTimestamp(
                    editorPlayhead
                )}{" "}
                /{" "}
                {formatEditorTimestamp(
                    editorDuration
                )}
            </p>
        </div>
    </div>

    <div
        className="
            relative
            mt-3
            overflow-x-auto
            rounded-xl
            border
            border-[#ffd166]/20
            bg-black
            p-2
        "
    >
        {isGeneratingEditorThumbnails ? (
            <div
                className="
                    flex
                    min-h-[105px]
                    items-center
                    justify-center
                    text-xs
                    text-[#d8b4fe]
                "
            >
                Creating video slides...
            </div>
        ) : editorThumbnails.length > 0 ? (
            <div className="flex min-w-max gap-1.5">
{editorThumbnails
    .filter((thumbnail) =>
        editorSegments.some(
            (segment) =>
                !segment.deleted &&
                thumbnail.time >=
                    segment.start &&
                thumbnail.time <=
                    segment.end
        )
    )
    .map(
        (thumbnail) => (
                        <button
                            key={
                                thumbnail.id
                            }
                            type="button"
                            onClick={() =>
                                seekRecordingEditorTo(
                                    thumbnail.time
                                )
                            }
                            className={`
                                relative
                                w-28
                                shrink-0
                                overflow-hidden
                                rounded-lg
                                border
                                bg-black
                                transition
                                ${
                                    Math.abs(
                                        editorPlayhead -
                                            thumbnail.time
                                    ) <
                                    Math.max(
                                        0.5,
                                        editorDuration /
                                            Math.max(
                                                editorThumbnails.length,
                                                1
                                            ) /
                                            2
                                    )
                                        ? "border-[#d8b4fe] shadow-[0_0_12px_rgba(216,180,254,0.65)]"
                                        : "border-[#ffd166]/20 hover:border-[#ffd166]"
                                }
                            `}
                        >
                            <img
                                src={
                                    thumbnail.image
                                }
                                alt={`Video at ${formatEditorTimestamp(
                                    thumbnail.time
                                )}`}
                                className="
                                    aspect-video
                                    w-full
                                    object-cover
                                "
                            />

                            <span
                                className="
                                    absolute
                                    bottom-1
                                    right-1
                                    rounded
                                    bg-black/80
                                    px-1
                                    py-0.5
                                    text-[8px]
                                    font-semibold
                                    text-[#fff3c4]
                                "
                            >
                                {formatEditorTimestamp(
                                    thumbnail.time
                                )}
                            </span>
                        </button>
                    )
                )}
            </div>
        ) : (
            <div
                className="
                    flex
                    min-h-[105px]
                    items-center
                    justify-center
                    text-xs
                    text-[#b0b8d6]
                "
            >
                Video slides are not available,
                but the playhead and sections can
                still be used.
            </div>
        )}
    </div>

    <div
    className="
        mt-3
        rounded-xl
        border
        border-[#d8b4fe]/25
        bg-[#12091f]
        p-3
    "
>
    <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
            <p className="text-[10px] uppercase tracking-[0.15em] text-[#b0b8d6]">
                Cut begins
            </p>

            <p className="text-sm font-semibold tabular-nums text-[#ffd166]">
                {formatEditorTimestamp(
                    editorTrimStart
                )}
            </p>
        </div>

        <div className="text-center">
            <p className="text-[10px] uppercase tracking-[0.15em] text-[#d8b4fe]">
                Selected footage
            </p>

            <p className="text-sm font-semibold tabular-nums text-[#f1ddff]">
                {formatEditorTimestamp(
                    Math.max(
                        0,
                        editorTrimEnd -
                            editorTrimStart
                    )
                )}
            </p>
        </div>

        <div className="text-right">
            <p className="text-[10px] uppercase tracking-[0.15em] text-[#b0b8d6]">
                Cut ends
            </p>

            <p className="text-sm font-semibold tabular-nums text-[#ffd166]">
                {formatEditorTimestamp(
                    editorTrimEnd
                )}
            </p>
        </div>
    </div>

    <div className="relative mt-3 h-8">
        <div
            className="
                absolute
                left-0
                right-0
                top-1/2
                h-2
                -translate-y-1/2
                rounded-full
                border
                border-[#ffd166]/20
                bg-black
            "
        />

        <div
            className="
                absolute
                top-1/2
                h-2
                -translate-y-1/2
                rounded-full
                border-y
                border-red-300/40
                bg-gradient-to-r
                from-[#7f1d1d]/75
                via-[#6b214f]/80
                to-[#7f1d1d]/75
                shadow-[0_0_14px_rgba(248,113,113,0.45)]
            "
            style={{
                left: `${
                    editorDuration > 0
                        ? (editorTrimStart /
                              editorDuration) *
                          100
                        : 0
                }%`,
                width: `${
                    editorDuration > 0
                        ? (Math.max(
                              0,
                              editorTrimEnd -
                                  editorTrimStart
                          ) /
                              editorDuration) *
                          100
                        : 0
                }%`,
            }}
        />

        <input
            type="range"
            min="0"
            max={Math.max(
                editorDuration,
                0.1
            )}
            step="0.05"
            value={editorTrimStart}
            onChange={(event) => {
                const nextStart =
                    Number(
                        event.target.value
                    ) || 0;

                setEditorTrimStart(
                    Math.min(
                        nextStart,
                        Math.max(
                            0,
                            editorTrimEnd -
                                0.1
                        )
                    )
                );

                seekRecordingEditorTo(
                    nextStart
                );
            }}
            aria-label="Cut begins"
            className="shadow-cut-range z-20"
        />

        <input
            type="range"
            min="0"
            max={Math.max(
                editorDuration,
                0.1
            )}
            step="0.05"
            value={editorTrimEnd}
            onChange={(event) => {
                const nextEnd =
                    Number(
                        event.target.value
                    ) || 0;

                setEditorTrimEnd(
                    Math.max(
                        nextEnd,
                        Math.min(
                            editorDuration,
                            editorTrimStart +
                                0.1
                        )
                    )
                );

                seekRecordingEditorTo(
                    nextEnd
                );
            }}
            aria-label="Cut ends"
            className="shadow-cut-range z-30"
        />
    </div>

    <p className="mt-1 text-center text-[10px] text-red-200">
        The highlighted footage between
        the two purple handles will be
        removed.
    </p>
</div>

<div className="recording-editor-action-row mt-3 flex flex-wrap items-center gap-2">
    <button
        type="button"
        onClick={
            removeSelectedRecordingRange
        }
        disabled={
            editorTrimEnd -
                editorTrimStart <
            0.15
        }
        className={`${editorGoldButtonClass} ${
            isSelectedRangePreviewing
                ? "is-active"
                : ""
        }`}
    >
        Remove Selected Footage
    </button>

    <button
        type="button"
        onClick={
            previewSelectedRecordingRange
        }
        disabled={
            editorTrimEnd -
                editorTrimStart <
            0.15
        }
        className={`${editorGoldButtonClass} ${
            isSelectedRangePreviewing
                ? "is-active"
                : ""
        }`}
    >
        {isSelectedRangePreviewing
            ? "Playing Selection..."
            : "Preview Selected Section"}
    </button>

    <button
        type="button"
        onClick={
            restoreAllRecordingCuts
        }
        disabled={
            !editorSegments.some(
                (segment) =>
                    segment.deleted
            )
        }
        className={
            editorGoldButtonClass
        }
    >
        Restore Removed Footage
    </button>

    <button
        type="button"
        onClick={() =>
            seekRecordingEditorTo(0)
        }
        className={
            editorGoldButtonClass
        }
    >
        Go to Beginning
    </button>

    <label
        className={`${editorGoldButtonClass} cursor-pointer ${
    editorMuteOriginalAudio
        ? "is-active"
        : ""
}`}
    >
        <input
            type="checkbox"
            checked={
                editorMuteOriginalAudio
            }
            onChange={(event) =>
                setEditorMuteOriginalAudio(
                    event.target.checked
                )
            }
            className="
                h-3.5
                w-3.5
                accent-[#d8b4fe]
            "
        />

        <span>
            Mute Original Audio
        </span>
    </label>
</div>
<div
    className="
        recording-editor-action-row
        mt-4
        grid
        grid-cols-2
        gap-2
        sm:grid-cols-4
    "
>
    <button
        type="button"
        onClick={
            previewRecordingSelection
        }
        disabled={
            !editorSegments.some(
                (segment) =>
                    !segment.deleted
            )
        }
        className={`${editorPurpleButtonClass} ${
            isEditorPreviewing
                ? "is-active"
                : ""
        }`}
    >
        {isEditorPreviewing
            ? "Previewing..."
            : "Preview Edited Video"}
    </button>

    <button
        type="button"
        onClick={() => {
            void saveRecordingDraft();
        }}
        disabled={
            isSavingVideoDraft ||
            !recordingUrl
        }
        className={`${editorPurpleButtonClass} ${
            isSavingVideoDraft
                ? "is-active"
                : ""
        } ${
        videoDraftSaveMessage ===
            "Draft Saved"
                ? "is-success"
                : ""
        }`}
    >
        {isSavingVideoDraft
            ? "Saving Draft..."
            : videoDraftSaveMessage ||
              "Save Video Draft"}
    </button>

    <button
        type="button"
        onClick={() => {
            void renderRecordingEdits();
        }}
        disabled={
            isRenderingEditedRecording ||
            !editorSegments.some(
                (segment) =>
                    !segment.deleted
            )
        }
        className={
            editorPurpleButtonClass
        }
    >
        {isRenderingEditedRecording
            ? "Rendering..."
            : "Save Edited Video"}
    </button>

    <button
        type="button"
        onClick={
            closeRecordingEditor
        }
        className={
            editorPurpleButtonClass
        }
    >
        Back to Review
    </button>
</div>
<div
    className="
        mt-4
        rounded-2xl
        border
        border-[#ffd166]/15
        bg-black/35
        p-3
    "
>
    <div className="flex items-center justify-between gap-2">
        <p className="text-xs font-semibold text-[#ffd166]">
            Edited Video Sections
        </p>

        <span className="text-[10px] text-[#b0b8d6]">
            {editorSegments.filter(
                (segment) =>
                    !segment.deleted
            ).length}{" "}
            visible section
            {editorSegments.filter(
                (segment) =>
                    !segment.deleted
            ).length === 1
                ? ""
                : "s"}
        </span>
    </div>

    <div className="mt-2 space-y-2">
        {editorSegments.filter(
            (segment) =>
                !segment.deleted
        ).length > 0 ? (
            editorSegments
                .filter(
                    (segment) =>
                        !segment.deleted
                )
                .sort(
                    (
                        firstSegment,
                        secondSegment
                    ) =>
                        firstSegment.start -
                        secondSegment.start
                )
                .map(
                    (
                        segment,
                        index
                    ) => (
                        <button
                            key={
                                segment.id
                            }
                            type="button"
                            onClick={() =>
                                seekRecordingEditorTo(
                                    segment.start
                                )
                            }
                            className="
                                flex
                                w-full
                                items-center
                                gap-3
                                rounded-xl
                                border
                                border-[#ffd166]/20
                                bg-black
                                px-3
                                py-2
                                text-left
                                transition
                                hover:border-[#d8b4fe]
                                hover:shadow-[0_0_12px_rgba(216,180,254,0.25)]
                            "
                        >
                            <span
                                className="
                                    flex
                                    h-8
                                    w-8
                                    shrink-0
                                    items-center
                                    justify-center
                                    rounded-lg
                                    bg-[#2b1548]
                                    text-[11px]
                                    font-bold
                                    text-[#ffd166]
                                "
                            >
                                {index + 1}
                            </span>

                            <span className="min-w-0 flex-1">
                                <span className="block text-xs font-semibold text-[#fff3c4]">
                                    Edited Section{" "}
                                    {index + 1}
                                </span>

                                <span className="block text-[10px] tabular-nums text-[#b0b8d6]">
                                    {formatEditorTimestamp(
                                        segment.start
                                    )}{" "}
                                    →{" "}
                                    {formatEditorTimestamp(
                                        segment.end
                                    )}
                                </span>
                            </span>

                            <span className="text-[10px] font-semibold text-[#d8b4fe]">
                                View
                            </span>
                        </button>
                    )
                )
        ) : (
            <div
                className="
                    rounded-xl
                    border
                    border-red-400/25
                    bg-red-950/20
                    px-3
                    py-3
                    text-center
                    text-xs
                    text-red-200
                "
            >
                No footage is currently visible.
                Click Restore Removed Footage.
            </div>
        )}
        </div>
</div>
</div>
</div>
</div>
)}

{workspaceMode === "shared" && (
    <div
        className="
            flex
            shrink-0
            items-center
            justify-between
            gap-2
            border-b
            border-[#7cc1ff]/20
            bg-[#07121d]
            px-3
            py-1.5
            text-[10px]
        "
    >
        <span className="text-[#9dcff5]">
            {role === "parent" ? "Live sharing" : "Live with parent"}
            {role === "parent" && <select aria-label="Live sharing audience" className="ml-2 rounded border border-[#7cc1ff]/30 bg-black p-1 text-[#9dcff5]" value={sharedWorkspace?.participant_mode || "selected"} disabled={sharedStatus === "loading" || sharedStatus === "saving"} onChange={event => changeLiveAudience(event.target.value)}><option value="selected">This child</option><option value="all">All children</option></select>}
        </span>

        <span
            className={
                sharedStatus === "error"
                    ? "text-red-300"
                    : sharedStatus ===
                        "saved"
                      ? "text-emerald-300"
                      : "text-[#b0b8d6]"
            }
        >
            {sharedStatus === "loading"
                ? "Opening..."
                : sharedStatus === "saving"
                  ? "Saving..."
                  : sharedStatus === "saved"
                    ? "Saved"
                    : sharedStatus === "error"
                      ? sharedError
                      : "Ready"}
        </span>
    </div>
)}
<div
    className={`
        min-h-0
        flex-1
        p-2
        ${
            activeWorkspace === "whiteboard"
                ? "overflow-auto"
                : "overflow-hidden"
        }
    `}
>
    {activeWorkspace === "notepad" && (
        <NotebookWorkspace
            notes={notes}
            onNotesChange={handleNotesChange}
            notebookPages={notebookPages}
            setNotebookPages={setNotebookPages}
            activeNotebookPageId={
                activeNotebookPageId
            }
            setActiveNotebookPageId={
                setActiveNotebookPageId
            }
            notebookPagesStorageKey={
                notebookPagesStorageKey
            }
            isExpanded={isExpanded}
        />
    )}

    {activeWorkspace === "resources" && (
        <ArchivumWorkspace
            folders={folders}
            activeFolderId={activeFolderId}
            setActiveFolderId={
                setActiveFolderId
            }

            newFolderName={newFolderName}
            setNewFolderName={
                setNewFolderName
            }

            newFolderDescription={
                newFolderDescription
            }
            setNewFolderDescription={
                setNewFolderDescription
            }

            isResourceFolderCreatorOpen={
                isResourceFolderCreatorOpen
            }
            setIsResourceFolderCreatorOpen={
                setIsResourceFolderCreatorOpen
            }

            editingFolderId={
                editingFolderId
            }
            editingFolderName={
                editingFolderName
            }
            setEditingFolderName={
                setEditingFolderName
            }

            editingFolderDescription={
                editingFolderDescription
            }
            setEditingFolderDescription={
                setEditingFolderDescription
            }

            createFolder={createFolder}
            startEditingFolder={
                startEditingFolder
            }
            cancelEditingFolder={
                cancelEditingFolder
            }
            saveEditedFolder={
                saveEditedFolder
            }
            deleteFolder={deleteFolder}

            setNotes={setNotes}
            setActiveWorkspace={
                setActiveWorkspace
            }
        />
    )}

    {activeWorkspace === "whiteboard" && (
        <TabulaWorkspace
            isExpanded={isExpanded}
            workspaceMode={workspaceMode}
            onSharedEditing={() => {
                sharedBusyRef.current = true;
                sharedEpochRef.current += 1;
            }}
            sharedStatus={sharedStatus}
            sharedWorkspace={
                sharedWorkspace
            }
            activeFolderId={
                activeFolderId
            }
            childId={childId}
            scope={scope}
            title={title}
            handleSharedTabulaChange={
                handleSharedTabulaChange
            }
        />
    )} 
    
</div>

</div>

        </aside>
    );
};

export default ChildNotesPanel;